const messages = {
  es: {
    translations: {
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          company: "Nombre de la Empresa",
          phone: "Whatsapp (COD + NÚMERO)",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        title: "Inicio de Sesión",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
          button: "Ingresar",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
      },
      companies: {
        title: "Registrar Empresa",
        form: {
          name: "Nombre de la Empresa",
          plan: "Plan",
          token: "Token",
          submit: "Registrar",
          success: "Empresa creada con éxito!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
        dueDate: {
          expiration: "Suscripción caducará en",
          days: "días!",
          day: "día!",
          expirationToday: "Su suscripción termina hoy!",
        },
        token: "Token",
      },
      dashboard: {
        title: "Dashboard",
        loadingMessage: "Los datos del Dashboard se cargarán pronto...",
        refreshing: "Actualizando datos...",
        pleaseWait: "Por favor espere",
        tabs: {
          indicators: "Indicadores",
          assessments: "Evaluaciones",
          attendants: "Agentes",
        },
        hero: {
          inService: "En Atención",
          ticketsNow: "tickets ahora",
          pending: "Pendientes",
          waitingService: "esperando atención",
          criticalTooltip: "Tickets esperando hace más de 30 minutos",
          critical: "críticos",
          avgWaitTime: "T.M.E. Actual",
          avgWaitLabel: "tiempo medio de espera",
          maxWait: "Mayor espera",
          nps: "NPS Score",
          promoters: "Promotores",
          passives: "Pasivos",
          detractors: "Detractores",
        },
        sections: {
          operational: "Visión Operativa",
          deepAnalysis: "Análisis Detallado",
          aiIntelligence: "Inteligencia & IA",
        },
        loading: "Cargando...",
        kpis: {
          resolutionRate: "Resolución",
          resolved: "resueltos",
          abandonmentRate: "Abandono",
          leftQueue: "salieron de la cola",
          slaFirstResponse: "SLA 1ª Resp.",
          under5min: "< 5 min",
          reopened: "Reabiertos",
          ticketsReopened: "tickets reabiertos",
          finished: "Finalizados",
          closedPeriod: "en el período",
          demand: "Demanda",
          activeDemand: "Empresa inició",
          passiveDemand: "Cliente inició",
          activeVsPassive: "activa vs pasiva",
        },
        health: {
          title: "Salud del Servicio",
          excellent: "Excelente",
          attention: "Atención",
          critical: "Crítico",
          basedOn: "Basado en",
          indicators: "indicadores",
          pendingQueue: "Pendientes en cola",
          avgWaitTime: "Tiempo medio espera",
          slaCompliance: "Cumplimiento SLA",
          abandonRate: "Tasa de abandono",
          npsScore: "Score NPS",
        },
        heatmap: {
          title: "Mapa de Calor Semanal",
          less: "Menos",
          more: "Más",
          peak: "Pico",
          total: "Total",
          avgPerDay: "Promedio/día",
          peakSlot: "Pico (2h)",
          days: {
            dom: "Dom",
            seg: "Lun",
            ter: "Mar",
            qua: "Mié",
            qui: "Jue",
            sex: "Vie",
            sab: "Sáb",
          },
        },
        demand: {
          title: "Origen de los Tickets",
          companyInitiated: "Empresa inició",
          clientInitiated: "Cliente inició",
        },
        ai: {
          title: "IA Autónoma",
          noData: "Sin datos de IA autónoma en el período",
          totalInteractions: "Interacciones",
          tokensUsed: "Tokens usados",
          estimatedCost: "Costo est.",
          handoffRate: "Tasa de handoff",
          avgConfidence: "Confianza promedio",
          handoffReasons: "Motivos de handoff",
          noHandoffs: "Sin handoffs en el período",
          reasons: {
            respond: "Respondido",
            handoff: "Handoff",
            ignore: "Ignorado",
            clarify: "Clarificar",
            escalate: "Escalar",
          },
        },
        queues: {
          title: "Colas en Tiempo Real",
          noData: "Sin datos de colas disponibles",
          pending: "Pendientes",
          inProgress: "En atención",
          onlineAgents: "Agentes en línea",
          moreQueues: "colas adicionales",
          totalPending: "Pendientes",
          totalInProgress: "Atendiendo",
          totalOnline: "En línea",
        },
        sentiment: {
          title: "Sentimiento",
          noData: "Sin datos de sentimiento en el período",
          positive: "Positivo",
          neutral: "Neutral",
          negative: "Negativo",
          frustrated: "Frustrado",
          score: "Score de",
          satisfaction: "Satisfacción",
          total: "total",
        },
        leads: {
          title: "Embudo de Leads",
          noData: "Sin datos de leads en el período",
          newContacts: "Nuevos Contactos",
          qualified: "Calificados",
          negotiation: "En Negociación",
          converted: "Convertidos",
          conversionRate: "Tasa conversión",
          totalLeads: "Total leads",
          avgTicketValue: "Ticket promedio",
          totalValue: "Valor total",
        },
        campaigns: {
          title: "Campañas",
          noData: "Sin campañas en el período",
          sent: "Enviados",
          delivered: "Entregados",
          read: "Leídos",
          failedCount: "Fallos",
          deliveryRate: "Tasa entrega",
          active: "Activas",
          recent: "Recientes",
          completed: "Completada",
          running: "En curso",
          scheduled: "Programada",
          failed: "Falló",
          paused: "Pausada",
        },
        voice: {
          title: "Voice AI",
          noData: "Sin datos de llamadas en el período",
          totalCalls: "Llamadas",
          resolutionRate: "Resolución",
          avgDuration: "Duración promedio",
          cost: "Costo est.",
          outcomes: "Resultados",
          resolved: "Resueltas",
          transferred: "Transferidas",
          voicemail: "Buzón de voz",
          dropped: "Abandonadas",
          noAnswer: "Sin respuesta",
          dailyCalls: "Llamadas por día",
        },
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
          messages: "Mensajes",
          ticketFlow: "Flujo de Tickets",
          opened: "Abiertos",
          closed: "Cerrados",
          noData: "Sin datos para el período seleccionado",
          attendantRanking: "Ranking de Agentes",
          attendants: "agentes",
          noAttendants: "Ningún agente encontrado",
          name: "Nombre",
          tickets: "Tickets",
          avgWait: "TME",
          avgSupport: "TMA",
          rating: "Evaluación",
          channelDist: "Distribución por Canal",
          totalTickets: "tickets",
          hourlyActivity: "Actividad por Hora",
          peakHour: "Pico",
          pendingByQueue: "Pendientes por Sector",
          pending: "Pendientes",
          total: "total",
          noPending: "Sin tickets pendientes",
          topContacts: "Top Contactos",
          noContacts: "Ningún contacto encontrado",
          avgServiceTime: "Tiempo medio",
          timeMetrics: "Métricas de Tiempo",
          avgWaitTime: "TME",
          avgSupportTime: "TMA",
          firstResponse: "1ª Respuesta",
          time: "Tiempo (min)",
          statusDist: "Distribución por Estado",
          channelTrend: "Tendencia por Canal",
          forecast: "Previsión",
        },
        messageVolume: {
          title: "Volumen de Mensajes",
          tooltip: "Total de mensajes enviados, recibidos y fallos de envío por día",
          sent: "Enviados",
          received: "Recibidos",
          failed: "Fallos",
          failureRate: "Tasa",
          failureRateTooltip: "Porcentaje de mensajes que fallaron del total enviado",
          topErrors: "Principales errores de envío",
          noData: "Sin datos de mensajes para el período",
        },
        cards: {
          inAttendance: "Atención actual",
          waiting: "Esperando",
          activeAttendants: "Agentes Activos",
          finalized: "Finalizados",
          newContacts: "Nuevos Contactos",
          totalReceivedMessages: "Total de Mensajes Recibidas",
          totalSentMessages: "Total de Mensajes Enviadas",
          averageServiceTime: "T.P. de Atención",
          averageWaitingTime: "T.P. de Espera",
          status: "Status (Actual)",
          activeTickets: "Tickets Activos",
          passiveTickets: "Tickets Pasivos",
          groups: "Grupos",
          totalTickets: "Total de Tickets",
          avgWaitTimeNow: "T.M.E. Actual",
          maxWaitTimeNow: "Mayor Espera",
          criticalPending: "Pendientes Críticos",
          abandonmentRate: "Tasa de Abandono",
          firstResponseSLA: "SLA 1ª Respuesta",
        },
        avgWaitTimeNowTooltip: "Tiempo medio de espera de los tickets pendientes actualmente",
        maxWaitTimeNowTooltip: "Tiempo de espera del ticket más antiguo en la cola",
        criticalPendingTooltip: "Tickets esperando hace más de 30 minutos",
        abandonmentRateTooltip: "Tickets cerrados antes de ser atendidos",
        firstResponseSLATooltip: "Porcentaje de tickets atendidos en menos de 5 minutos",
        pendingNow: "Pendientes ahora",
        bottleneck: "Cuello de botella actual",
        over30min: "> 30 min de espera",
        closedBeforeService: "Cerrados sin atención",
        under5min: "Atendidos en < 5 min",
        pendingByQueue: {
          sectionTitle: "Monitoreo de Pendientes por Sector",
          title: "Pendientes por Sector",
          pending: "Pendientes",
          total: "pendientes",
          totalTooltip: "Total de tickets esperando atención",
          ok: "< 15 min",
          alert: "15-30 min",
          critical: "> 30 min",
          empty: "Sin tickets pendientes",
          emptySubtext: "¡Todos los sectores están al día!",
          avgWait: "Espera promedio",
        },
        noQueue: "Sin sector",
        users: {
          name: "Nombre",
          numberAppointments: "Total de tickets",
          statusNow: "Actual",
          totalCallsUser: "Total de atención por usuario",
          totalAttendances: "Total de atenciones",
        },
        date: {
          initialDate: "Fecha Inicial",
          finalDate: "Fecha Final",
        },
        licence: {
          available: "Disponíble hasta",
        },
        filters: {
          title: "Filtros",
          apply: "Filtrar",
          reset: "Limpiar Filtros",
          quickFilters: "Filtros Rápidos",
          customRange: "Período Personalizado",
          allTime: "Todo el Período",
          today: "Hoy",
          yesterday: "Ayer",
          last7days: "Últimos 7 días",
          thisWeek: "Esta semana",
          thisMonth: "Este mes",
          lastMonth: "Mes pasado",
          sections: "Visibilidad de Secciones",
          refreshInterval: "Intervalo de actualización:",
          refreshManual: "Manual",
          refresh5min: "5 minutos",
          refresh15min: "15 minutos",
          refresh30min: "30 minutos",
          until: "hasta",
          hideSection: "Ocultar sección",
          showAll: "Mostrar Todas",
          hideAll: "Ocultar Todas",
          queuePlaceholder: "Filtrar por sector",
          noQueues: "Sin sectores",
          userPlaceholder: "Filtrar por agente",
          noUsers: "Sin agentes",
          connectionPlaceholder: "Filtrar por conexión",
          noConnections: "Sin conexiones",
        },
        assessments: {
          totalCalls: "Total de Tickets",
          callsWaitRating: "Tickets aguardando evaluación",
          callsWithoutRating: "Ticket sin evaluación",
          ratedCalls: "Tickets evaluados",
          evaluationIndex: "Índice de evaluación",
          score: "Puntaje",
          prosecutors: "Promotores",
          neutral: "Neutrales",
          detractors: "Dectratores",
          ratingTooltip: "de los tickets evaluados",
        },
        tickets: {
          overview: "Estado de los Tickets",
          timeline: "Timeline de Atenciones",
          created: "Tickets Creados",
          active: "Tickets activos actualmente",
          pending: "Tickets esperando atención",
          completed: "Atenciones completadas",
          demandActive: "Demanda activa",
          demandPassive: "Demanda pasiva",
          inAttendanceTooltip: "Tickets que están siendo atendidos en este momento",
          waitingTooltip: "Tickets que aún no han sido asignados a un agente",
          finalizedTooltip: "Tickets que han sido cerrados y resueltos",
          activeTicketsTooltip: "Tickets iniciados por la empresa",
          passiveTicketsTooltip: "Tickets iniciados por el cliente",
        },
        messages: {
          title: "Mensajes por Período",
          received: "Recibidos",
          sent: "Enviados",
          total: "Total",
          ratio: "Proporción",
        },
        attendants: {
          performance: "Ranking de Agentes",
          online: "En línea ahora",
        },
        topContacts: {
          title: "Ranking de Contactos",
          columns: {
            contact: "Contacto",
            tickets: "Tickets",
            queue: "Sector",
            time: "Tiempo",
          },
          noData: "Sin contactos para mostrar",
          tooltip: "Top 10 contactos con más tickets abiertos en el período",
          openTicket: "Abrir ticket",
          statusOpen: "Abierto",
          statusPending: "Pendiente",
          statusClosed: "Cerrado",
        },
        actions: {
          filter: "Filtrar",
          refresh: "Actualizar",
          fullscreen: "Pantalla completa",
          exitFullscreen: "Salir de pantalla completa",
        },
        online: "En línea ahora",
        serviceTime: "Tiempo medio de atención",
        waitingTime: "Tiempo medio de espera en cola",
        newContacts: "Nuevos contactos en el período",
        fromLastMonth: "desde el mes pasado",
        newContactsTooltip: "Nuevos contactos registrados en el período seleccionado",
        activeAttendantsTooltip: "Número de agentes disponibles en línea",
        timeMetrics: "Métricas de Tiempo",
        firstResponseTooltip: "Tiempo medio hasta la primera respuesta del agente",
        resolutionRateTooltip: "Porcentaje de tickets resueltos en relación al total",
        reopenedTicketsTooltip: "Tickets reabiertos después del cierre",
        avgTicketsPerDayTooltip: "Promedio diario de tickets en el período",
        firstResponseTime: "Primera Respuesta",
        refresh: "Actualizar datos",
        sort: {
          ascending: "Ascendente",
          descending: "Descendente",
          orderBy: "Ordenar por",
          tickets: "Número de Tickets",
          rating: "Evaluación",
          waitTime: "Tiempo de Espera",
          serviceTime: "Tiempo de Atención",
        },
        status: {
          open: "Abiertos",
          pending: "Pendientes",
          closed: "Cerrados",
          nps: "Evaluación",
        },
        export: {
          pdf: "Exportar PDF",
        },
        sla: {
          detailTitle: "SLA 1ª Respuesta Detallado",
          under1min: "< 1 min",
          "1to5min": "1-5 min",
          "5to15min": "5-15 min",
          "15to30min": "15-30 min",
          over30min: "> 30 min",
          totalResponses: "Total de respuestas",
          under5min: "Respondidos < 5 min",
          noData: "Sin datos de SLA para el período",
        },
        goals: {
          target: "Meta",
        },
        alerts: {
          highWaitTime: "TME actual por encima de 10 minutos ({{value}} min)",
          criticalPending: "Hay {{count}} tickets críticos sin respuesta",
          highAbandonment: "Tasa de abandono elevada: {{rate}}%",
          npsDrop: "NPS cayó {{delta}} puntos respecto al período anterior",
        },
        callbacks: {
          title: "Retornos & Transferencias",
          noData: "Sin reaperturas ni transferencias en el período",
          reopened: "Reaperturas",
          transfers: "Transferencias",
          uniqueReopened: "Tickets Reabiertos",
        },
        aiInsights: {
          title: "Insights con IA",
          generate: "Generar Insights",
          generating: "Generando insights...",
          empty: "Haga clic para generar insights sobre sus datos",
          error: "Error al generar insights",
        },
        geo: {
          title: "Distribución Geográfica",
          noData: "Sin datos geográficos en el período",
          totalStates: "Estados",
          totalTickets: "Total de Tickets",
        },
      },
      reports: {
        title: "Reporte de Pesquisas Realizadas",
        operator: "Agente",
        period: "Período",
        until: "Hasta",
        date: "Fecha",
        reportTitle: "Relatorios",
        calls: "Atenciones",
        search: "Pesquisas",
        durationCalls: "Duración de la atención",
        grupoSessions: "Atención en grupos grupos",
        groupTicketsReports: {
          timezone: "America/Monterrey",
          msgToast: "Generando relatorio compactado, por favor espere.",
          errorToast: "Erro ao generar relatorio",
          back: "Volver",
          groupServiceReport: "Relatorio de Atención en Grupos",
          loading: "Cargando...",
          contact: "Contacto",
          dateOpen: "Fecha de Apertura",
          dateLastUpdated: "Fecha Ultima Actualización",
          agent: "Agente",
          agentClosed: "Agente(cerró)",
          waitingAssistance: "Esperando atención",
          process: "En proceso",
        },
        researchReports: {
          response: "respuesta",
          active: "(Activa)",
          inactive: "(Inactiva)",
          quantity: "Cantidade",
          percentage: "porcentaje",
          title: "Relatorio de Pesquisas Realizadas",
          activeSearch: "Pesquisa activa",
          inactiveSearch: "Pesquisa inactiva",
        },
        ticketDurationDetail: {
          msgToast: "Generando relatorio compactado, por favor espere.",
          title: "Relatorio de Duración de la Atención",
          startService: "Início de la Atención",
          lastUpdated: "Última actualización",
          lastAgent: "Último agente",
          durationFinished: "Duración después de finalizado",
        },
        ticketDuration: {
          title: "Relatorio de Duración de Atención",
          contact: "Contacto",
          open: "Abiertos",
          pending: "Pendientes",
          finished: "Finalizados",
          durationFinished: "Duración de los finalizados",
          durationAfterFinished: "Duración después de finalizado",
          actions: "Acciones",
        },
        ticketReports: {
          msgToast: "Generando relatorio compactado, por favor aguarde.",
          title: "Relatrio de Atención",
        },
        pdf: {
          title: "Relación de Atenciones Realizadas",
          exportTitle: "Relación de Atenciones en Grupos Realizadas",
        },
      },
      todo: {
        newTask: "Nueva Tarea",
        add: "Agregar",
        task: "Tareas",
      },
      contactImportWpModal: {
        title: "Exportar Contactos para Excel",
        buttons: {
          downloadModel: "Download - modelo de excel para importación",
          closed: "Cerrar",
          import: "Seleccione el archivo de excel para importar los Contactos",
        },
      },
      connections: {
        title: "Conexiones",
        waitConnection: "Espere... Las conexiones serán reiniciadas!",
        newConnection: "Nueva Conexión",
        restartConnections: "Reiniciar Conexiones",
        callSupport: "Soporte",
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
          closedimported:
            "Estamos cerrando los tickets importados, por favor espere.",
        },
        confirmationModal: {
          closedImportedTitle: "Cerrar tickets importados",
          closedImportedMessage:
            "¿Seguro? Todos los tickets importados seran cerrados.",
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
          transferLabel:
            "Seleccione la nueva conexión que recibirá los tickets",
          transferHelper:
            "Los tickets permanecerán en las mismas filas después de la transferencia.",
          transferUnavailable:
            "No hay otra conexión disponible para este canal. Cree una nueva antes de eliminar.",
          noTransferOption:
            "No hay otra conexión disponible para transferencia. Si hay tickets o contactos, se perderán.",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          closedImported: "Cerrar todos los tickets Importados",
          preparing: "Preparando mensajes para importación",
          importing: "Importando Mensajes del WhatsApp",
          processed: "Processado",
          in: "de",
          connecting: "Conectando",
          resolvePasskey: "Resolver autenticación",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Fecha del mensaje",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
          number: "Número de Whatsapp",
        },
        status: {
          connected: "En línea",
          disconnected: "Desconectado",
          opening: "Abriendo",
          qrcode: "QR",
          timeout: "Timeout",
          pairing: "Emparejando",
          passkeyRequired: "Passkey requerida",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Servicio existente",
        },
        form: {
          message: "Hay un ticket abierto para este contacto:",
          user: "Agente",
          queue: "Fila",
          messageWait: "Este contacto ya está en espera.",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Historico",
        },
        options: {
          create: "Ticket creado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: "iniciou la atención.",
          access: "accesó el ticket.",
          transfered: "transferió el ticket.",
          receivedTransfer: "recibió el ticket transferido.",
          pending: "regresó a la fila.",
          closed: "cerró el ticket",
          reopen: "abrió el ticket",
        },
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        tabs: {
          general: "Geral",
          messages: "Mensajes",
          assessments: "Evaluaciones",
          integrations: "Integraciones",
          schedules: "Horario de trabajo",
        },
        form: {
          importOldMessagesEnable: "Importar mensajes del celular",
          importOldMessages: "Fecha de inicio",
          importRecentMessages: "Fecha Final",
          importOldMessagesGroups: "Importar mensajes de grupo",
          closedTicketsPostImported: "Cerrar tickets después de la importación",
          name: "Nombre",
          queueRedirection: "Redirección de Fila",
          queueRedirectionDesc:
            "Seleccione una fila para los contactos que no tienen una fila para redirigir",
          default: "Por Defecto",
          group: "Permitir grupos",
          timeSendQueue: "Tiempo en minutos para redireccionar a la fila",
          importAlert:
            "ATENCIÓN: Guardando, su conexión será cerrada, usted tendrá que volver a leer el QR Code para importar los mensajes",
          groupAsTicket: "Grupos como Ticket",
          timeCreateNewTicket: "Iniciar un nuevo ticket en *n* minutos",
          maxUseBotQueues:
            "Cantidad máxima de veces que el chatbot va a ser enviado",
          timeUseBotQueues: "Tiempo en minutos para nuevo envío del chatbot",
          expiresTicket: "Cerrar chats abiertos após *n* horas",
          expiresTicketNPS:
            "Cerrar chats aguardando la evaluacion luego de x minutos",
          maxUseBotQueuesNPS:
            "Cantidad máxima de veces que la evaluación será enviada",
          closeLastMessageOptions1: "Del Agente/Cliente",
          closeLastMessageOptions2: "Del Agente",
          outOfHoursMessage: "Mensaje fuera de horario de atención",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de conclusión",
          lgpdLinkPrivacy: "Link para políticas de privacidad",
          lgpdMessage: "Mensaje inicial de LPD",
          lgpdDeletedMessages: "Ofuscar mensaje borrada por el contacto",
          lgpdSendMessage: "Siempre solicitar confirmación del contacto",
          ratingMessage: "Mensaje de evaluación - Rango de 0 a 10",
          token: "Token para integración externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensaje de inactividad",
          timeInactiveMessage:
            "Tiempo em minutos para el envío del aviso de inactividad",
          whenExpiresTicket:
            "Cerrar chats abiertos cuando el último mensaje sea",
          expiresInactiveMessage: "Mensaje al cerrar por inactividade",
          prompt: "Prompt",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Activado",
          disabled: "Desactivado",
          minutes: "minutos",
        },
        success: "WhatsApp guardado satisfactoriamente.",
        errorSendQueue:
          "Además del tiempo debes seleccinar una fila para redirecionar. Se necesitan los dos campos.",
        errorExpiresNPS:
          "Es necesario llenar el tiempo para la evaluación para el NPS.",
        errorGreetingMessage:
          "El mensaje de saludo es obligatorio cuando se seleccionan dos o más colas.",
        queueRequired:
          "Es necesario seleccionar una fila para la importación de mensajes.",
        vacationDatesRequired:
          "Las fechas de inicio y fin de las vacaciones colectivas son obligatorias cuando se completa el mensaje de vacaciones.",
        invalidDates:
          "La fecha de inicio no puede ser posterior a la fecha de fin de las vacaciones colectivas.",
        errorExpiresInactiveMessage:
          "El mensaje de cierre por inactividad es obligatorio cuando se configura el tiempo de expiración del ticket.",
        errorTimeInactiveMessage:
          "El tiempo para el envío del aviso de inactividad es obligatorio cuando se completa el mensaje de inactividad.",
        npsDisabled:
          "NPS está deshabilitado en la configuración de la empresa. Configure en: Configuración > Empresa",
        queueSelected:
          "Filas seleccionadas. El Prompt y las Integraciones están deshabilitados.",
        promptSelected:
          "Prompt seleccionado. Las Filas e Integraciones están deshabilitadas.",
        integrationSelected:
          "Integración seleccionada. Las Filas y el Prompt están deshabilitados.",
        importInfo:
          "La conexión se reiniciará para importar los mensajes. Espere el proceso de reconexión e importación.",
        status: {
          connected: "En línea",
          opening: "Abriendo",
          qrcode: "QR",
          disconnected: "Desconectado",
          timeout: "Timeout",
          pairing: "Emparejando",
          destroyed: "Destruido",
        },
      },
      profilePermissions: {
        title: "Permisos de Acceso",
        description: "Defina qué menús pueden ver supervisores y agentes.",
        helper: "Ajuste las selecciones y haga clic en 'Guardar cambios' para aplicar inmediatamente.",
        roles: {
          supervisor: "Supervisor",
          user: "Agente",
        },
        table: {
          menu: "Menú",
        },
        actions: {
          save: "Guardar cambios",
          cancel: "Revertir cambios",
        },
        toasts: {
          updated: "¡Permisos actualizados con éxito!",
        },
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
        passkey: {
          modalTitle: "Resolver passkey",
          title: "Se requiere autenticación por passkey",
          detecting: "Detectando la extensión...",
          connectingTitle: "Conectando...",
          connecting: "Sesión enviada. Esperando que WhatsApp se conecte...",
          ready: {
            description:
              "Esta conexión necesita una nueva autenticación de WhatsApp. Haz clic abajo para resolverla de forma segura a través de la extensión del navegador.",
          },
          install: {
            title: "Instala la extensión para continuar",
            description:
              "La resolución del passkey se realiza mediante una extensión del navegador. Instálala y recarga esta página.",
            step1: "Descarga la extensión (archivo .crx o carpeta descomprimida).",
            step2: "Abre chrome://extensions y activa el Modo de desarrollador.",
            step3: "Haz clic en 'Cargar descomprimida' y selecciona la carpeta de la extensión.",
            step4: "Recarga esta página para detectar la extensión.",
          },
          existingSession: {
            title: "Ya hay otra cuenta conectada",
            message: "Ya existe una cuenta conectada en este navegador:",
            unknownNumber: "otra cuenta",
            question: "¿Deseas desconectarla y continuar?",
          },
          buttons: {
            resolve: "Resolver autenticación",
            retry: "Intentar de nuevo",
            cancel: "Cancelar",
            clearAndContinue: "Desconectar y continuar",
            migrateToWaba: "Migrar a WABA oficial",
          },
          errors: {
            noUrl: "No se pudo obtener la URL de importación. Inténtalo de nuevo.",
            generic: "Error al importar la sesión. Inténtalo de nuevo.",
            withReason: "Error al importar la sesión: {{reason}}",
          },
          connectionFailed: {
            title: "No se pudo conectar",
            description:
              "La sesión se importó, pero la conexión con WhatsApp falló. Inténtalo de nuevo.",
            withReason: "No se pudo conectar: {{reason}}",
            timeoutTitle: "No se pudo conectar — tiempo agotado",
            timeoutDescription:
              "La sesión se importó, pero no recibimos confirmación de la conexión a tiempo. Inténtalo de nuevo.",
          },
        },
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          exportContact: "Exportar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
          blockContact: "¿Estás seguro que quieres bloquear este contacto?",
          unblockContact:
            "¿Estás seguro que quieres desbloquear este contacto?",
          importMessage: "¿Quieres importar todos los contactos del teléfono?",
          importChat: "Importar Conversaciones",
          wantImport:
            "¿Quieres importar todas las conversaciones del teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
          export: "Exportar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
          lastMessage: "Ultimo Mensaje",
        },
        menu: {
          importYourPhone: "Importar del celular por default",
          importToExcel: "Importar / Exportar Contactos",
        },
      },
      forwardMessage: {
        text: "Reenviada",
      },
      forwardMessageModal: {
        title: "Reenviar mensaje",
        buttons: {
          ok: "Reenviar",
        },
      },
      promptModal: {
        form: {
          name: "Nombre",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens en la respuesta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensajes del Historico",
          voiceKey: "Llave de la API de la Voz",
          voiceRegion: "Región de la Voz",
        },
        success: "Prompt guardado",
        title: {
          add: "Agregar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nombre",
          queue: "Sector/Fila",
          max_tokens: "Máximo Tokens Respuestas",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "¿Estás seguro? ¡Esta acción no se puede revertir!",
        },
        buttons: {
          add: "Agregar Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
          chatBotContact: "Desactivar chatbot para este contacto",
          termsLGDP: "Términos P.P. aceptados en:",
          allTicket: "Visualizar tickets sin fila",
          allowGroup: "Permitir grupos",
        },
        errors: {
          numberWithDDI:
            "Incluya el código de país. Use 55 para Brasil (p. ej., 5511999999999) o el código correspondiente (p. ej., +12125551234)",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
      },
      queueModal: {
        title: {
          queueData: "Datos de la fila",
          text: "Horarios de atención",
          add: "Agregar fila",
          edit: "Editar fila",
          confirmationDelete:
            "¿Está seguro? Todas las opciones integradas también se eliminarán.",
        },
        form: {
          name: "Nombre",
          color: "Color",
          orderQueue: "Orden de la fila (Bot)",
          rotate: "Rotativo",
          timeRotate: "Tiempo de Rotación",
          rotateHelp: {
            title: "Cómo funciona la Rotación",
            content: "Cuando está activado, asigna automáticamente un agente disponible al ticket. El tiempo define cuánto tiempo tiene el agente para responder antes de que el ticket sea transferido a otro agente de la fila.",
          },
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de cierre",
          outOfHoursMessage: "Mensaje fuera de horario de atención",
          token: "Token",
          none: "Ninguno",
          integrationId: "Integración",
          flowId: "FlowBuilder",
          flowPriorityHelp: "FlowBuilder e Integración son excluyentes: configure solo uno de ellos en la fila. Para cambiar, quite primero el que está seleccionado.",
          flowIntegrationConflict: "No es posible guardar la fila con FlowBuilder e Integración al mismo tiempo. Quite uno de los dos.",
          fileListId: "Listado de archivos",
          closeTicket: "Cerrar ticket",
          queueType: "Tipo de menu",
          message: "Mensaje de respuesta",
          queue: "Fila para transferencia",
          integration: "Integración",
          file: "Listado de archivos",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Editar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opciones",
          toolTipTitle: "Agregue las opciones para construir un chatbot",
          toolTip:
            "Si solo hay una opción, se elegirá automáticamente, lo que hará que el bot responda con el mensaje de la opción y avance.",
          selectOption: "Seleccione una opción",
          text: "Texto",
          attendent: "Agente",
          queue: "Fila",
          integration: "Integranción",
          file: "Archivo",
          toolTipMessageTitle:
            "El mensaje es obligatorio para pasar al siguiente nivel",
          toolTipMessageContent:
            "El mensaje es obligatorio para pasar al siguiente nivel",
          selectUser: "Seleccione un Usuario",
          selectQueue: "Seleccione una Fila",
          selectIntegration: "Seleccione um Integración",
          addOptions: "Agregar opciones",
        },
        serviceHours: {
          dayWeek: "Día",
          startTimeA: "Hora de Inicio",
          endTimeA: "Hora del término",
          startTimeB: "Hora de Inicio",
          endTimeB: "Hora del término",
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Miércoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "Sabado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Agregar proyecto",
          edit: "Editar proyecto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo en minutos para expirar una conversación",
          typebotKeywordFinish: "Palabra para finalizar la conversación",
          typebotUnknownMessage: "Mensaje de opción invalida",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot",
        },
        messages: {
          testSuccess: "¡Integración testada con éxito!",
          addSuccess: "¡Integración agregada con éxito!",
          editSuccess: "¡Integración editada con éxito!",
        },
      },
      userModal: {
        warning:
          "Para importar los mensajes por favor vuelva a leer el QRCode.",
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
          updateImage: "Actualizar Imagen",
          removeImage: "Excluir Imagen",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          farewellMessage: "Mensaje de despedida",
          profile: "Perfil",
          startWork: "Inicio del Horario",
          endWork: "Final del Horario",
          whatsapp: "Conexión Defautl",
          allTicketEnable: "Activado",
          allTicketDisable: "Desactivado",
          allTicket: "Visualizar mensajes sin fila",
          allowGroup: "Permitir Grupos",
          allHistoric: "Ver historicos",
          allHistoricEnabled: "Activado",
          allHistoricDisabled: "Desactivado",
          allUserChat: "Ver conversación de otros usuarios",
          userClosePendingTicket: "Permitir cerrar tickets pendientes",
          showDashboard: "Ver Dashboard",
        },
        tabs: {
          general: "General",
          permissions: "Permissos",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addImage: "Agregar Imagen",
          editImage: "Editar Imagen",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      companyModal: {
        title: {
          add: "Agregar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          passwordDefault: "Contraseña",
          numberAttendants: "Usuarios",
          numberConections: "Conexiones",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "La Empresa fue guardada satisfactoriamente.",
      },
      scheduleModal: {
        title: {
          add: "Nuevo Programa",
          edit: "Editar Programa",
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Fecha del Programa",
          sentAt: "Fecha de Envío",
        },
        sections: {
          recurrence: "Recurrencia",
          templateWaba: "Template WABA",
          recurrenceDescription:
            "Define si el envío se repite y qué hacer si cae en fin de semana.",
        },
        templateWaba: {
          description:
            "Selecciona un template aprobado para envío oficial vía WABA (opcional).",
          templateLabel: "Template WABA",
          none: "Ninguno",
          helper: "Templates disponibles para la conexión WABA seleccionada.",
          loading: "Cargando templates...",
          language: "Idioma",
          parametersTitle: "Variables del template",
          parameterLabel: "Variable",
          parameterHelper: "Ingresa el valor que se enviará en el template.",
          noParameters: "Este template no tiene variables.",
          unsupportedHeaderMedia:
            "Este template usa medios en el header y no está soportado en el agendamiento.",
          unsupportedButtons:
            "Este template tiene variables en botones y no está soportado en el agendamiento.",
          missingParameters:
            "Completa todas las variables del template antes de guardar.",
          attachmentsBlocked: "Los adjuntos no se usan con template WABA.",
          attachmentsBlockedHint:
            "Los adjuntos no se usan cuando un template WABA está seleccionado.",
        },
        helper: {
          interval:
            "Elige la unidad: días, semanas, meses o minutos.",
          intervalValue:
            "0 = sin repetición. 1+ = repetir.",
          sendTimes:
            "0 = solo el envío actual. 1+ = repeticiones adicionales.",
          dayType: "Elige cómo ajustar cuando la fecha caiga en fin de semana.",
        },
        helpModal: {
          title: "Ayuda de Recurrencia",
          intro:
            "Usa la recurrencia para repetir el envío automáticamente después de la fecha inicial.",
          examplesTitle: "Ejemplos reales",
          examples:
            "Cada semana: Intervalo = Semanas, Valor = 1, Enviar = 4 (envío ahora + 4 semanas).\nCada mes: Intervalo = Meses, Valor = 1, Enviar = 2 (envío ahora + 2 meses).\nCada 10 días: Intervalo = Días, Valor = 10, Enviar = 3 (envío ahora + 3 repeticiones).\nFin de semana: Tipo de Envío = \"un día hábil después\" (cae sábado, envía el lunes).",
          tips:
            "Tip: Valor 0 no repite. \"Enviar cuántas veces\" es el número de repeticiones adicionales. Si cae en fin de semana, elige adelantar o posponer.",
          close: "Cerrar",
          aria: "Abrir ayuda de recurrencia",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          close: "Cerrar",
        },
        success: "Programa guardado satisfactoriamente.",
        readOnlyAttachments:
          "Este programa ya fue enviado. Las ediciones están deshabilitadas.",
      },
      tagModal: {
        title: {
          add: "Nueva Tag",
          edit: "Editar Tag",
          addKanban: "Nueva Lane",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nombre",
          color: "Color",
          semanticTitle: "Categorización automática (IA)",
          semanticDescription: "Descripción semántica",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Tag guardada satisfactoriamente.",
        successKanban: "Lane guardada satisfactoriamente.",
      },
      fileModal: {
        title: {
          add: "Agregar menú de evaluación",
          edit: "Editar menú de evaluación",
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Agregar archivo",
        },
        form: {
          name: "Nombre",
          message: "Mensaje de Evaluación",
          options: "Opciones de Evaluación",
          extraName: "Nombre de la opción",
          extraValue: "Valor de la opción",
        },
        success: "Evaluación guardada satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTRE Y SUELTE LOS ARCHIVOS EN EL CAMPO ⬇️",
          titleFileList: "Listado de archivo(s)",
        },
      },
      chatInternal: {
        title: "Chat Interno",
        new: "Nuevo",
        selectChat: "Selecciona un chat para empezar",
        emptyState: "Selecciona una conversación para empezar",
        buttons: {
          new: "Nuevo",
        },
        modal: {
          conversation: "Inicio",
          title: "Título",
          filterUsers: "Filtro por Usuarios",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Excluir Chat",
          message: "Esta acción no se puede revertir, ¿confirmar?",
        },
        messages: {
          deleted: "Mensaje eliminado",
          deletedVisible: "Eliminado",
          edited: "editado",
        },
        contextMenu: {
          reply: "Responder",
          react: "Reaccionar",
          edit: "Editar",
          delete: "Eliminar",
        },
        editDialog: {
          title: "Editar Mensaje",
          placeholder: "Escribe el nuevo mensaje...",
          original: "Original",
          cancel: "Cancelar",
          save: "Guardar",
        },
      },
      ticketsManager: {
        questionCloseTicket: "¿Quieres cerrar todos los tickets?",
        yes: "SI",
        not: "NO",
        buttons: {
          newTicket: "Nuevo",
          resolvAll: "Resolver Todos",
          close: "Cerrar",
          new: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        showAll: {
          lockedByTeam: "Activo por participación en equipo — los tickets de compañeros deben estar visibles para las notificaciones de equipo",
        },
        inbox: {
          closedAllTickets: "¿Cerrar todos los tickets?",
          closedAll: "Cerrar Todos",
          newTicket: "Nuevo Ticket",
          yes: "SI",
          no: "NO",
          open: "Abiertos",
          resolverd: "Resueltos",
        },
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
          redirectedToExisting: "Ya existe un ticket abierto para este contacto. Has sido redirigido.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes.",
          filterConections: "Filtro por Conexión",
          filterConectionsOptions: {
            open: "Abierto",
            closed: "Cerrado",
            pending: "Pendiente",
          },
          filterUsers: "Filtro por usuarios",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Regresar a la Fila",
          scredule: "Programar",
          deleteTicket: "Borrar Ticket",
        },
        closedTicket: {
          closedMessage: "Cerrar CON un mensaje de despedida",
          closedNotMessage: "Cerrar SIN un mensaje de despedida",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Seleccione una fila",
        fieldWhatsapp: "Seleccione un whatsapp",
        noOptions: "No se encontraron usuarios con ese nombre",
        msgTransfer:
          "Observación - los mensajes internos, no serán visualizados por el cliente.",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        called: "Entradas",
        today: "Hoy",
        missedCall: "Llamada de voz/vídeo perdida a las",
        pendingHeader: "Esperando",
        assignedHeader: "Trabajando en",
        groupingHeader: "Grupos",
        noTicketsTitle: "¡Nada acá!",
        noTicketsMessage:
          "No se encontraron tickets con este estado o término de búsqueda",
        noQueue: "Sin Fila",
        noLastMessage: "Sin vista previa",
        buttons: {
          accept: "Aceptar",
          cancel: "Cancelar",
          start: "Iniciar",
          closed: "Cerrar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
        },
        acceptModal: {
          title: "Aceptar Chat",
          queue: "Seleccionar tag",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Agregar",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contacto",
        fieldLabel: "Buscar contacto",
        add: "Agregar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          chatsTempoReal: "Panel de Asistencia",
          tickets: "Inbox",
          quickMessages: "Respuestas Rápidas",
          contacts: "Contactos",
          queues: "Filas",
          tags: "Tags",
          administration: "Administración",
          companies: "Empresas",
          users: "Usuarios",
          settings: "Configuración",
          profilePermissions: "Permisos de Perfil",
          ratings: "Regist. Evaluaciones",
          helps: "Ayuda",
          messagesAPI: "API",
          voiceApi: "Voice AI API",
          schedules: "Programa",
          campaigns: "Campañas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financiero",
          queueIntegration: "Integraciones",
          version: "Versión",
          kanban: "Kanban",
          prompts: "Talk.Ai",
          aiTools: "Integraciones IA",
          allConnections: "Admin conexiones",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
            message: "Hola",
            messageEnd: "bienvenido a",
            active: "Activo hasta",
            goodMorning: "Hola,",
            myName: "mi nombre es",
            continuity: "y te seguiré apoyando.",
            virtualAssistant: "Asistente Virtual",
            token:
              "Token inválido, favor comunicarse con el administrador de la plataforma.",
          },
          message: {
            location: "Localización",
            contact: "Contacto",
          },
          notRegister: "No hay registros",
          refresh: "Atuaclizar",
        },
      },
      languages: {
        undefined: "Idioma",
        "es-Mx": "Español",
        es: "Español",
        en: "English",
        tr: "Türkçe",
      },
      messagesAPI: {
        title: "API",
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
          userId: "ID usuario/agente",
          queueId: "ID Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado",
        },
        API: {
          title: "Documentación para envío de mensajes",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensajes de Texto",
            messagesMidia: "Mensajes de Midia",
          },
          instructions: {
            title: "Instrucciones",
            comments: "Observaciones Importantes",
            comments1:
              "Antes de enviar mensajes, es necesario registrar el token vinculado a la conexión que enviará los mensajes. <br />Para registrarse, acceda al menú 'Conexiones', haga clic en el botón de edición de la conexión e inserte el token en el campo correspondiente.",
            comments2:
              "El número de envío no debe tener máscara ni caracteres especiales y debe constar de:",
            codeCountry: "Código del País",
            code: "Código del Estado",
            number: "Numero",
          },
          text: {
            title: "1. Mensajes de Texto",
            instructions:
              "A continuación se muestra la lista de información necesaria para enviar mensajes de texto:",
          },
          media: {
            title: "2. Mensagens de Media",
            instructions:
              "A continuación se muestra la lista de información necesaria para enviar mensajes con archivos:",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
      },
      common: {
        cancel: "Cancelar",
        next: "Siguiente",
        back: "Atrás",
        save: "Guardar",
        saving: "Guardando...",
        close: "Cerrar",
        confirm: "Confirmar",
        delete: "Eliminar",
        edit: "Editar",
        add: "Agregar",
        search: "Buscar",
        loading: "Cargando...",
        yes: "Sí",
        no: "No",
        ok: "OK",
      },
      aiTools: {
        title: "Integraciones IA",
        steps: {
          connector: "Conector",
          endpoint: "Endpoint",
          parameters: "Parámetros",
          response: "Respuesta",
          access: "Acceso",
        },
        table: {
          name: "Nombre",
          endpoint: "Endpoint",
          category: "Categoría",
          stats: "Estadísticas",
          status: "Estado",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Integración",
          refresh: "Actualizar",
          createFirst: "Crear primera integración",
        },
        filters: {
          search: "Buscar por nombre...",
          category: "Categoría",
          status: "Estado",
          all: "Todos",
          active: "Activo",
          inactive: "Inactivo",
        },
        status: {
          active: "Activo",
          inactive: "Inactivo",
        },
        actions: {
          test: "Probar",
          logs: "Ver logs",
          edit: "Editar",
          delete: "Eliminar",
        },
        stats: {
          executions: "ejecuciones",
        },
        empty: {
          noTools: "Ninguna integración configurada",
          noResults: "No se encontraron resultados",
          description: "Configure integraciones para que la IA pueda interactuar con sistemas externos.",
        },
        confirmDelete: {
          title: "Eliminar Integración",
          message: "¿Está seguro de que desea eliminar la integración '{{name}}'?",
        },
        messages: {
          createSuccess: "¡Integración creada con éxito!",
          updateSuccess: "¡Integración actualizada con éxito!",
          deleteSuccess: "¡Integración eliminada con éxito!",
          activated: "¡Integración activada!",
          deactivated: "¡Integración desactivada!",
        },
        modal: {
          titleCreate: "Nueva Integración",
          titleEdit: "Editar Integración",
          selectConnector: "Seleccione un conector",
          selectTemplate: "Seleccione una plantilla",
          configureEndpoint: "Configurar endpoint",
          authentication: "Autenticación",
          configureParameters: "Configurar parámetros",
          parametersDescription: "Defina los parámetros que la IA puede pasar a esta integración.",
          configureResponse: "Configurar respuesta",
          configureAccess: "Control de acceso",
        },
        fields: {
          name: "Nombre técnico",
          nameHelp: "Usado internamente (ej: crear_ticket)",
          displayName: "Nombre de visualización",
          description: "Descripción",
          descriptionHelp: "Describa qué hace esta integración para que la IA entienda cuándo usarla.",
          baseUrl: "URL Base",
          path: "Ruta (path)",
          method: "Método HTTP",
          username: "Usuario",
          password: "Contraseña",
          headerName: "Nombre del Header",
          successPath: "JSONPath de éxito",
          successTemplate: "Plantilla de éxito",
          templateHelp: "Use {{result}} para insertar el valor extraído",
          jsonPathHelp: "Ej: $.data.id o $.response.ticket_id",
          errorPath: "JSONPath de error",
          errorTemplate: "Plantilla de error",
          isActive: "Integración activa",
          allowedQueues: "Filas permitidas",
          allowedQueuesPlaceholder: "Seleccione las filas...",
          allowedQueuesHelp: "Deje vacío para permitir en todas las filas",
          allowedAgents: "Agentes de IA permitidos",
          allowedAgentsPlaceholder: "Seleccione los agentes...",
          allowedAgentsHelp: "Deje vacío para permitir en todos los agentes",
          allowedContactNumbers: "Teléfonos autorizados (whitelist)",
          allowedContactNumbersHelp: "Deje vacío para permitir cualquier contacto. Cuando esté lleno, solo estos números podrán ejecutar esta herramienta.",
          allowedContactNumbersWarning: "Atención: solo {{count}} número(s) autorizado(s) podrán ejecutar esta herramienta. Los contactos no autorizados recibirán un mensaje de acceso denegado.",
        },
        parameters: {
          name: "Nombre",
          type: "Tipo",
          description: "Descripción",
          required: "Obligatorio",
          expand: "Opciones avanzadas",
          remove: "Eliminar",
          add: "Agregar parámetro",
          addFirst: "Agregar primer parámetro",
          empty: "Ningún parámetro definido. La IA no podrá pasar datos a esta integración.",
          advanced: "Opciones avanzadas",
          default: "Valor predeterminado",
          minLength: "Mín. caracteres",
          maxLength: "Máx. caracteres",
          min: "Valor mínimo",
          max: "Valor máximo",
          enumValues: "Valores permitidos",
          addEnumValue: "Agregar valor",
        },
        test: {
          title: "Probar Integración",
          parameters: "Parámetros de prueba",
          noParameters: "Esta integración no requiere parámetros.",
          dryRun: "Modo simulación (dry run)",
          dryRunDescription: "No ejecuta la llamada real, solo valida los parámetros.",
          dryRunWarning: "Modo simulación activo. La llamada real no se ejecutará.",
          execute: "Ejecutar prueba",
          testing: "Probando...",
          result: "Resultado",
          rawResponse: "Respuesta completa",
          request: "Solicitud que se enviaría",
        },
        logs: {
          title: "Logs de Ejecución",
          totalExecutions: "Total de ejecuciones",
          successRate: "Tasa de éxito",
          avgLatency: "Latencia promedio",
          errors: "Errores",
          status: "Estado",
          startDate: "Fecha inicial",
          endDate: "Fecha final",
          date: "Fecha",
          latency: "Latencia",
          ticket: "Ticket",
          httpStatus: "HTTP",
          input: "Entrada (Input)",
          output: "Salida (Output)",
          error: "Error",
          noLogs: "No se encontraron logs de ejecución.",
        },
        connectorHelp: {
          title: "Ayuda de Configuración",
          showHelp: "Ver documentación",
          hideHelp: "Ocultar documentación",
          viewFullDocs: "Ver documentación completa",
          authSection: "Autenticación",
          fieldsSection: "Campos",
          ixc: {
            title: "IXC Proveedor (ERP)",
            description: "Integración con el sistema IXC Soft para proveedores de internet.",
            requirements: "Requisitos",
            authHelp: "Use Basic Auth con token en formato 'ID:TOKEN'",
            fieldsHelp: "Campos obligatorios: id_ticket_setor, titulo, menssagem",
          },
          milvus: {
            title: "Milvus Help Desk",
            description: "Integración con el sistema Milvus para gestión de tickets de soporte.",
            requirements: "Requisitos",
            authHelp: "Use Bearer Token con token de API generado en el panel Milvus",
            fieldsHelp: "Campos obligatorios: titulo, descricao, categoria_id",
          },
          zendesk: {
            title: "Zendesk Support",
            description: "Integración con Zendesk para gestión de tickets de soporte.",
            requirements: "Requisitos",
            authHelp: "Use Basic Auth con email/token o Bearer Token",
            fieldsHelp: "Campos obligatorios: subject, description, requester",
          },
          triatox: {
            title: "Triatox Laboratorio",
            description: "Integración con el sistema Triatox para laboratorios.",
            requirements: "Requisitos",
            authHelp: "Use credenciales proporcionadas por soporte Triatox",
            fieldsHelp: "Consulte documentación específica de Triatox",
          },
          generic: {
            title: "API REST Genérica",
            description: "Configure cualquier API REST. Ideal para integraciones personalizadas.",
            requirements: "Requisitos",
            authHelp: "Elija tipo de autenticación: Bearer, Basic, API Key o Header personalizado",
            fieldsHelp: "Configure parámetros según documentación de la API",
          },
          custom: {
            title: "Configuración Manual",
            description: "Configure todos los detalles manualmente, sin plantilla predefinida.",
            requirements: "Requisitos",
            authHelp: "Configure autenticación según documentación de la API",
            fieldsHelp: "Defina todos los parámetros necesarios manualmente",
          },
        },
        responsePresets: {
          title: "Presets de Mapeo",
          description: "Seleccione un preset o configure manualmente",
          custom: "Personalizado",
          standard: "Estándar ($.data.id)",
          ixcTicket: "IXC - Ticket ($.id)",
          milvusTicket: "Milvus - Ticket ($.chamado.id)",
          zendeskTicket: "Zendesk - Ticket ($.ticket.id)",
          restApi: "REST API ($.result)",
        },
        quickSetup: {
          title: "Configuración Rápida",
          credentialsStep: "Credenciales",
          autoConfigured: "✨ ¡Configuración automática! El endpoint, parámetros y mapeos ya fueron completados. Solo necesitas ingresar tus credenciales.",
          action: "Acción",
          endpoint: "Endpoint",
          parameters: "Parámetros de IA",
          moreParams: "más",
          credentials: "Tus Credenciales",
          urlHelp: "URL base de la API (pre-llenado, cambiar solo si es necesario)",
          tokenLabel: "Token de API / Clave de Acceso",
          tokenPlaceholder: "Pega tu token de API aquí",
          tokenHelp: "Token de autenticación obtenido del panel del sistema",
          advancedSettings: "Configuración Avanzada",
        },
      },
      quickMessages: {
        title: "Respuestas Rápidas",
        searchPlaceholder: "Buscar...",
        noAttachment: "No hay",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir. ¿Continuar?",
        },
        buttons: {
          add: "Agregar",
          attach: "Adjuntar Archivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atajo agregado satisfactoriamente.",
          deleted: "Atajo excluido satisfactoriamente.",
        },
        dialog: {
          title: "Mensaje Rápida",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          geral: "Global",
          add: "Agregar",
          edit: "Editar",
          visao: "Permitir visión",
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          actions: "Acciones",
          mediaName: "Nombre del Archivo",
          status: "Status",
        },
      },
      contactLists: {
        title: "Listado de Contactos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Listado",
        },
        dialog: {
          name: "Nombre",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      contactListItems: {
        title: "Contactos",
        searchPlaceholder: "Búsqueda",
        buttons: {
          add: "Nuevo",
          lists: "Listados",
          import: "Importar",
        },
        dialog: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
          importMessage: "¿Quieres importar esta plantilla? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Admin",
          tags: "Lanes",
        },
      },
      campaigns: {
        title: "Campañas",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Listados",
          listContacts: "Listados de contatos",
          settings: "Configuraciones",
        },
        settings: {
          randomInterval: "Intervalo de disparo aleatorio",
          noBreak: "Sin Intervalo",
          intervalGapAfter: "Intervalo mayor después de",
          undefined: "No definido",
          messages: "mensajes",
          laggerTriggerRange: "Intervalo de envío más grande",
          addVar: "Agregar variable",
          save: "Guardar",
          close: "Cerrar",
          add: "Agregar",
          shortcut: "Atajo",
          content: "Contenido",
        },
        buttons: {
          add: "Nueva Campaña",
          contactLists: "Listado de Contactos",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          contactList: "Listado de Contactos",
          option: "Ninguna",
          disabled: "Activada",
          enabled: "Desactivada",
          status: "Status",
          scheduledAt: "Programa",
          completedAt: "Finalizada",
          confirmation: "Confirmación",
          actions: "Acciones",
        },
        dialog: {
          new: "Nueva Campaña",
          update: "Editar Campaña",
          readonly: "Solo Visualizar",
          help: "Use variables como {nombre}, {numero}, {email} o defina variables personalizadas.",
          form: {
            name: "Nombre",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            confirmationMessage1: "Mensaje de Confirmación 1",
            confirmationMessage2: "Mensaje de Confirmación 2",
            confirmationMessage3: "Mensaje de Confirmación 3",
            confirmationMessage4: "Mensaje de Confirmación 4",
            confirmationMessage5: "Mensaje de Confirmación 5",
            messagePlaceholder: "Contenido del Mensaje",
            whatsapp: "Conexión",
            status: "Status",
            scheduledAt: "Programa",
            confirmation: "Confirmación",
            contactList: "Listado de Contacto",
            tagList: "Tags",
            statusTicket: "Status del Ticket",
            openTicketStatus: "Abierto",
            closedTicketStatus: "Cerrado",
            enabledOpenTicket: "Activado",
            disabledOpenTicket: "Desactivado",
            openTicket: "Abrir ticket",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar Envíos",
            restart: "Reiniciar Envíos",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          success: "Acción realizada satisfactoriamente",
          cancel: "Campaña cancelada",
          restart: "Campaña reiniciada",
          deleted: "Registro excluido",
        },
      },
      campaignReport: {
        title: "Reporte de",
        inactive: "Inactiva",
        scheduled: "Programada",
        process: "En Proceso",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campaña",
        validContacts: "Contactos Válidos",
        confirmationsRequested: "Confirmaciones Solicitadas",
        confirmations: "Confirmaciones",
        deliver: "Entregadas",
        connection: "Conexión",
        contactLists: "Listado de Contactos",
        schedule: "Programados",
        conclusion: "Conclusión",
      },
      announcements: {
        title: "Boletines",
        searchPlaceholder: "Búsqueda",
        active: "Activo",
        inactive: "Inactivo",
        buttons: {
          add: "Nuevo Boletin",
          contactLists: "Listados de Boletines",
          close: "Cerrar",
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Status",
          actions: "Acciones",
        },
        dialog: {
          edit: "Editar Boletin",
          add: "Nuevo Boletin",
          update: "Editar Boletin",
          readonly: "Solo visualizar",
          form: {
            priority: "Prioridad",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Status",
            high: "Alta",
            medium: "Mediana",
            low: "Baja",
            active: "Activo",
            inactive: "Inactivo",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          success: "Acción realizada satisfactoriamente",
          deleted: "Registro excluido",
        },
      },
      campaignsConfig: {
        title: "Configuraciones de Campañas",
      },
      // Wizard de Configuración de IA
      aiConfigurationWizard: {
        title: "Crear Configuración de IA",
        editTitle: "Editar Configuración de IA",
        success: "¡Configuración creada con éxito!",
        updateSuccess: "¡Configuración actualizada con éxito!",
        optional: "Opcional",
        back: "Volver",
        next: "Siguiente",
        skip: "Saltar",
        close: "Cerrar",
        create: "Crear Configuración",
        update: "Guardar Cambios",
        saving: "Guardando...",
        updating: "Actualizando...",
        steps: {
          basic: "Tipo",
          provider: "Proveedor",
          behavior: "Comportamiento",
          autonomous: "Autónomo",
          classifier: "Categorías",
          integrations: "Integraciones",
          review: "Revisión",
        },
        selectType: "Seleccione el tipo de IA",
        selectTypeSubtitle: "Esta es la primera decisión y define todo lo demás del asistente. La diferencia principal es si la IA habla o no con el cliente.",
        whenToUseLabel: "Cuándo usar: ",
        types: {
          assistant: {
            title: "Asistente",
            badge: "Apoya al agente",
            description: "No habla con el cliente. Genera sugerencias de respuesta, resúmenes y análisis para que el agente humano decida.",
            whenToUse: "La atención sigue siendo humana, pero más rápida con ayuda de la IA.",
          },
          autonomous: {
            title: "Modo Autónomo",
            badge: "Habla con el cliente",
            description: "Conversa directamente con el cliente y resuelve solo, transfiriendo a un humano cuando es necesario.",
            whenToUse: "Quieres que la IA atienda de punta a punta, sin humano en el ciclo.",
          },
          classifier: {
            title: "Clasificador",
            badge: "Solo dirige",
            description: "No conversa. Identifica la intención del mensaje y dirige el ticket a la cola o agente correcto.",
            whenToUse: "Quieres triaje automático antes de llegar a una cola/agente.",
          },
        },
        prompts: {
          sectionTitle: "Prompts de la IA",
          mainLabel: "Prompt Principal",
          mainBadge: "Base · usado siempre",
          autonomousLabel: "Instrucciones del Modo Autónomo",
          autonomousBadge: "Solo cuando atiende sola",
          classifierSectionTitle: "Prompts del Clasificador",
          classifierMainLabel: "Prompt de Clasificación",
          classifierMainBadge: "Cómo clasificar · opcional",
          classifierPersonaLabel: "Persona y Conocimiento",
          classifierPersonaBadge: "Usada en el sondeo · opcional",
          classifierTransitionLabel: "Mensaje de Transición",
          classifierTransitionBadge: "Al transferir · opcional",
        },
        configName: "Nombre de la Configuración",
        configNamePlaceholder: "Ej: Soporte Técnico, Ventas, Clasificador Principal...",
        configNameHelper: "Un nombre descriptivo para identificar esta configuración",
        activeConfig: "Configuración Activa",
        activeConfigHelper: "Desactive para pausar temporalmente esta IA",
        selectProvider: "Seleccione el Proveedor",
        selectModel: "Modelo",
        modelPlaceholder: "Seleccione o escriba el modelo",
        apiKey: "API Key",
        apiKeyPlaceholder: "Pegue su API Key aquí",
        apiKeyRequired: "Ingrese la API Key",
        connectionSuccess: "¡Conexión exitosa!",
        connectionFailed: "Fallo en la conexión",
        connectionError: "Error al probar conexión",
        testing: "Probando...",
        testConnection: "Probar Conexión",
        testConnectionHint: "Recomendamos probar la conexión antes de continuar",
        advancedSettings: "Configuraciones Avanzadas",
        customEndpoint: "Endpoint Personalizado (opcional)",
        customEndpointHelper: "Use para proxies o endpoints alternativos",
        systemPrompt: "Prompt del Sistema",
        systemPromptHelper: "Defina la personalidad y comportamiento de la IA",
        useTemplate: "Usar plantilla:",
        promptPlaceholder: "Escriba las instrucciones para la IA...",
        maxTokens: "Max Tokens (por respuesta)",
        maxTokensTooltip: "Límite máximo de tokens en UNA respuesta de la IA. No confundir con 'Máx. Tokens por Sesión' (presupuesto de toda la atención, en el paso Autónomo).",
        temperature: "Temperatura",
        temperatureTooltip: "Controla la creatividad de las respuestas",
        features: "Funcionalidades Adicionales",
        featuresHelper: "Habilite funcionalidades extra (opcionales)",
        feature: {
          enableSuggestions: "Sugerencias",
          enableSummarization: "Resúmenes",
          enableTranslation: "Traducción",
          enableTranscription: "Transcripción",
        },
        autonomousMode: "Modo Autónomo",
        autonomousModeDescription: "La IA responde automáticamente sin intervención humana",
        autonomousPrompt: "Instrucciones Complementarias para Atención Autónoma",
        autonomousPromptHelper: "Instrucciones adicionales usadas solo cuando la IA está atendiendo sola. Complementa el prompt principal — no lo reemplaza (opcional)",
        autonomousPromptPlaceholder: "Ej: Cuando atienda sola, sea más directa y objetiva. Limite las respuestas a 3 frases...",
        autonomousPromptTip: "Estas instrucciones se agregan al Prompt Principal solo cuando la IA está respondiendo automáticamente (sin humano).",
        autonomousDisabledInfo: "El modo autónomo está deshabilitado. La IA funcionará solo como asistente para agentes.",
        classifierTitle: "Categorías de Intención",
        classifierDescription: "Configure las categorías para clasificar mensajes y direccionar automáticamente",
        classifierTip: "Consejo: Agregue palabras clave relevantes en cada categoría para mejorar la precisión de la clasificación. También puede vincular cada categoría a una cola específica o a un agente de IA especializado.",
        aiTools: "AI Tools (Function Calling)",
        aiToolsHelper: "Seleccione las herramientas que la IA podrá usar para consultar sistemas externos",
        noToolsAvailable: "Ninguna AI Tool disponible",
        createToolsHint: "Cree AI Tools en la página de herramientas",
        specificQueue: "Cola Específica (opcional)",
        allQueues: "Todas las colas",
        specificModels: "Modelos Específicos por Funcionalidad",
        specificModelsHelper: "Configure modelos diferentes para cada funcionalidad (deje vacío para usar el modelo principal)",
        sentimentAnalysis: "Análisis de Sentimiento",
        voiceTTS: "Voz (Text-to-Speech)",
        reviewTitle: "¡Todo listo!",
        reviewSubtitle: "Revise las configuraciones y haga clic en \"Crear Configuración\"",
        basicInfo: "Información Básica",
        provider: "Proveedor",
        behavior: "Comportamiento",
        integrations: "Integraciones",
        promptPreview: "Prompt del Sistema",
        quickTest: "Prueba Rápida (Opcional)",
        testPlaceholder: "Escriba un mensaje para probar la IA...",
        testOptional: "La prueba es opcional. Puede crear la configuración y probar después.",
      },
      queues: {
        title: "Filas",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          orderQueue: "Orden de la fila (bot)",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar fila",
        },
        toasts: {
          success: "Fila guardada",
          deleted: "Fila excluida",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa fila seguirán existiendo, pero ya no tendrán ninguna fila asignada.",
        },
      },
      queue: {
        queueData: "Datos",
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas solo para lectura",
      },
      teams: {
        title: "Equipos Colaborativos",
        description: "Los equipos permiten notificar a todos los miembros cuando un compañero recibe nuevos mensajes. Los compañeros reciben sonido y alerta visual.",
        noTeams: "No hay equipos creados en esta fila.",
        inactive: "Inactivo",
        form: {
          addTitle: "Nuevo Equipo",
          editTitle: "Editar Equipo",
          name: "Nombre del equipo",
          members: "Miembros",
          selectMembers: "Seleccionar miembros...",
        },
        buttons: {
          newTeam: "Nuevo Equipo",
          add: "Crear",
          save: "Guardar",
          edit: "Editar",
          delete: "Eliminar",
          cancel: "Cancelar",
        },
        toasts: {
          created: "¡Equipo creado con éxito!",
          updated: "¡Equipo actualizado con éxito!",
          deleted: "¡Equipo eliminado con éxito!",
        },
        confirmDelete: {
          title: "Eliminar equipo",
          message: "¿Está seguro de que desea eliminar este equipo? Los miembros dejarán de recibir notificaciones colaborativas.",
        },
        validation: {
          nameRequired: "El nombre del equipo es obligatorio.",
          membersRequired: "Seleccione al menos un miembro para el equipo.",
        },
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          lastUpdate: "Ultima actualización",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar Proyecto",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Se eliminarán las filas y conexiones enlazadas",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          status: "Status",
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          queues: "Filas",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán a la fila.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Activo",
          name: "Nombre",
          email: "Correo",
          password: "Contraseña",
          phone: "Teléfono",
          plan: "Plan",
          active: "Activo",
          numberAttendants: "Agentes",
          numberConections: "Conexiones",
          value: "Valor",
          namePlan: "Nombre del Plan",
          numberQueues: "Filas",
          useCampaigns: "Campañas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Programa",
          createdAt: "F.Creación",
          dueDate: "Caducidad",
          lastLogin: "Ult. Login",
          actions: "Acciones",
          money: "MXN",
          yes: "Si",
          no: "No",
          document: "CURP/RFC",
          recurrence: "Recurencia",
          monthly: "Mensual",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpiar",
          delete: "Eliminar",
          user: "Usuario",
          save: "Guardar",
        },
        buttons: {
          add: "Agregar empresa",
        },
        toasts: {
          deleted: "Empresa excluida satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todas las informaciones de la empresa serán eliminadas. Los tickets abiertos de este usuário serán movidos a la fila.",
        },
      },
      plans: {
        form: {
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          campaigns: "Campañas",
          schedules: "Programas",
          enabled: "Activada",
          disabled: "Desactivada",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Si",
          no: "No",
          money: "MXN",
          whatsappWuzapi: "WhatsApp (Wuzapi)",
          waba: "WhatsApp Business API (WABA)",
          webchat: "Webchat",
        },
      },
      helps: {
        title: "Ayuda",
        settings: {
          codeVideo: "Código del Video",
          description: "Descripción",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
        },
      },
      schedules: {
        title: "Programas",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir este Programa?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha del Programa",
          sentAt: "Fecha de Envío",
          status: "Status",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Programa",
        },
        toasts: {
          deleted: "Programa eliminado satisfactoriamente.",
        },
      },
      tags: {
        title: "Tags",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir esta Tag?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          name: "Nombre",
          kanban: "Kanban",
          color: "Color",
          tickets: "Registros Tags",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Tag",
        },
        toasts: {
          deleted: "Tag eliminada satisfactoriamente.",
        },
      },
      tagsKanban: {
        title: "Lanes",
        laneDefault: "Abierto(s)",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir esta Lane?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          name: "Nombre",
          color: "Color",
          tickets: "Tickets",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Lane",
        },
        toasts: {
          deleted: "Lane eliminada satisfactoriamente.",
        },
      },
      files: {
        title: "Listado de archivos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acción",
        },
        toasts: {
          deleted: "Listado borrado satisfactoriamente!",
          deletedAll: "Todos los listados fueron borrados satisfactoriamente!",
        },
        buttons: {
          add: "Agregar",
          deleteAll: "Borrar Todos",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteAllTitle: "Borrar Todos",
          deleteMessage: "Estás seguro de borrar este listado?",
          deleteAllMessage: "Estás seguro de borrar todos los listado?",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        tabs: {
          options: "Opciones",
          plans: "Planes",
          helps: "Ayuda",
          myPlan: "Mi Plan",
        },
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
          tabs: {
            options: "Opciones",
            schedules: "Horarios",
            plans: "Planes",
            help: "Ayuda",
          },
          options: {
            disabled: "Desactivadas",
            enabled: "Activadas",
            updating: "Actualizando...",
            creationCompanyUser: "Creación de Company/Usuário",
            evaluations: "Evaluaciones",
            officeScheduling: "Programar horarios",
            queueManagement: "Gerenciar por Fila",
            companyManagement: "Gerenciar por Empresa",
            connectionManagement: "Gerenciar por Conexión",
            sendGreetingAccepted: "Enviar saludos al aceptar ticket",
            sendMsgTransfTicket:
              "Enviar mensaje de transferencia (departamento/agente)",
            checkMsgIsGroup: "Ignorar mensajes de Grupos",
            chatBotType: "Tipo de Bot",
            userRandom: "Escojer agente aleatorio",
            buttons: "Botones",
            acceptCallWhatsapp: "No aceptar llamada en el whatsapp",
            sendSignMessage: "Permitir agente escoger ENVIAR Firma",
            sendGreetingMessageOneQueues:
              "Enviar saludos cuando hay solamente 1 fila",
            sendQueuePosition: "Enviar mensaje con la posición de la fila",
            sendFarewellWaitingTicket:
              "Enviar mensaje de despedida(estado Esperando)",
            acceptAudioMessageContact: "Aceptar audios de todos",
            enableLGPD: "Habilitar opción P.P.",
            requiredTag: "Tag obligatoria para cerrar ticket",
            requireClosureReason: "Clasificación obligatoria",
            closeTicketOnTransfer: "Cerrar ticket al transferir para otra fila",
            DirectTicketsToWallets:
              "Mover automaticamente cliente para cartera",
          },
          LGPD: {
            title: "Politica de Privacidad",
            welcome: "Mensaje de bienvenida (PP)",
            linkLGPD: "Link de la política de privacidad",
            obfuscateMessageDelete: "Ofuscar mensaje borrada",
            alwaysConsent: "Requerir siempre el consentimiento",
            obfuscatePhoneUser: "Ofuscar número de telefono para usuarios",
            enabled: "Activado",
            disabled: "Desactivado",
          },
          waba: {
            title: "WhatsApp Business API (WABA)",
            description: "Configure las opciones de conexión via API Oficial de WhatsApp Business",
            enableEmbeddedSignup: "Registro via Meta",
            enableWabaCoexistence: "Coexistencia",
            qualityAlerts: "Alertas de Calidad",
            maxConnections: "Límite de conexiones WABA",
            maxConnectionsHelp: "Máximo de conexiones WABA permitidas para esta empresa",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          dialogRatingTitle:
            "¿Quieres dejar un mensaje de evaluación para el cliente?",
          dialogClosingTitle: "Finalizando la atención al cliente!",
          dialogRatingCancel: "Cerrar CON Mensaje de Despedida",
          dialogRatingSuccess: "Cerrar y Enviar Evaluación",
          dialogRatingWithoutFarewellMsg: "Cerrar SIN Mensaje de Despedida",
          ratingTitle: "Elegir menú de evaluación",
          notMessage: "No hay mensaje seleccionado",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            rating: "Enviar Evaluación",
            enableIntegration: "Activar/Desactivar integración",
            logTicket: "Logs del Ticket",
            requiredTag:
              "Opps! Debes asignar una tag antes de cerrar el ticket.",
            activateAI: "Activar IA",
            deactivateAI: "Desactivar IA",
            activateAIConfirm: "Activar IA con el agente",
            activateAISuccess: "¡IA activada con éxito!",
            deactivateAISuccess: "IA desactivada. El operador ha retomado la conversación.",
            selectAgent: "Seleccionar Agente de IA",
          },
        },
        errors: {
          sendFailed: "Error al enviar el mensaje",
          window24hExpired: "⏰ Ventana de 24h expirada. Use una plantilla aprobada para volver a contactar al cliente.",
          rateLimit: "⚠️ Límite de mensajes alcanzado. Espere unos minutos.",
          blocked: "🚫 Este contacto ha bloqueado el número.",
          templateError: "📋 Error en la plantilla",
          invalidNumber: "📵 Número inválido o no es WhatsApp.",
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Entre como un mensaje o con / para respuestas rápidas",
        placeholderOpen:
          "Entre como un mensaje o con / para respuestas rápidas",
        placeholderClosed:
          "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
        privateMessage: "Mensaje Privada",
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Otras informaciones",
      },
      ticket: {
        tasks: {
          title: "Tareas",
          empty: "No hay tareas pendientes vinculadas a este ticket.",
          createNew: "Nueva Tarea",
          addTask: "Agregar tarea",
          pendingWarning: "Este ticket tiene tareas pendientes o en progreso.",
          closeConfirmTitle: "Hay tareas pendientes",
          closeConfirmMessage:
            "Este ticket tiene tareas pendientes o en progreso. ¿Deseas cerrarlo de todas formas?",
          closeAnyway: "Cerrar de todas formas",
        },
      },
      messageVariablesPicker: {
        label: "Variables disponibles",
        vars: {
          contactFirstName: "Primer Nombre",
          contactName: "Nombre",
          user: "Agente",
          greeting: "Saludos",
          protocolNumber: "Protocolo",
          date: "Fecha",
          hour: "Hora",
          ticket_id: "Nº del Ticket",
          queue: "Sector",
          connection: "Conexión",
        },
      },
      ticketOptionsMenu: {
        schedule: "Programa",
        delete: "Borrar",
        transfer: "Transferir",
        registerAppointment: "Observaciones del Contacto",
        resolveWithNoFarewell: "Cerrar sin despedida",
        acceptAudioMessage: "¿Aceptar audios del contacto?",
        appointmentsModal: {
          title: "Observaciones del Contacto",
          textarea: "Observación",
          placeholder: "Agregue aqui la información",
        },
        confirmationModal: {
          title: "¿Borrar ticket #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Activar/Desactivar firma",
          privateMessage: "Activar/Desactivar mensaje privado",
          meet: "Enviar link para videollamada",
          schedule: "Programar mensaje",
        },
        type: {
          imageVideo: "Fotos y videos",
          cam: "Cámara",
          contact: "Contacto",
          meet: "Link Jitsi Meet",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        edit: "Editar",
        forward: "Enviar",
        toForward: "Enviar",
        talkTo: "Platicar Con",
        downloadAudio: "Descargar Audio",
        markSpam: "Marcar como Spam",
        unmarkSpam: "Quitar de Spam",
        spamMarked: "Marcado como spam",
        spamToasts: {
          markedSynced: "Email marcado como spam y sincronizado con el proveedor",
          unmarkedSynced: "Email quitado de spam y sincronizado con el proveedor",
          markedLocal: "Email marcado como spam localmente (no sincronizado con proveedor)",
          unmarkedLocal: "Email quitado de spam localmente (no sincronizado con proveedor)",
        },
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      invoices: {
        table: {
          invoices: "Facturas",
          details: "Detalles",
          users: "Usuarios",
          connections: "Conexiones",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Fecha Venc.",
          action: "Acción",
        },
      },
      backendErrors: {
        ERR_WAPP_PAUSED:
          "La sesión de WhatsApp está en pausa. Reanude la conexión para enviar mensajes.",
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_TEMPLATE_NAME_ALREADY_EXISTS: "Ya existe una plantilla con este nombre.",
        ERR_NO_PERMISSION_DELETE_GROUP: "Solo los administradores pueden eliminar tickets de grupos.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_CONTACT_IN_OTHER_WALLET:
          "Este contacto está asignado a la cartera de otro agente. Solicita al administrador la transferencia.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una fila.",
        ERR_OUT_OF_HOURS: "¡Fuera del horario de oficina!",
        ERR_TRANSFER_WHATSAPP_REQUIRED:
          "Seleccione una conexión de destino para transferir los tickets antes de eliminar esta conexión.",
        ERR_TRANSFER_WHATSAPP_INVALID_TARGET:
          "La conexión seleccionada para la transferencia no es válida.",
        ERR_TRANSFER_WHATSAPP_TARGET_IN_REMOVAL:
          "La conexión elegida para la transferencia también será eliminada. Seleccione otra.",
        ERR_TRANSFER_WHATSAPP_TARGET_NOT_FOUND:
          "No se encontró una conexión de destino para esta empresa.",
        ERR_TRANSFER_WHATSAPP_CHANNEL_MISMATCH:
          "La conexión de destino debe pertenecer al mismo canal (WhatsApp, Facebook o Instagram).",
        ERR_TRANSFER_WHATSAPP_SAME_TARGET:
          "Seleccione una conexión diferente para la transferencia.",
        // Errores de Equipos Colaborativos
        ERR_TEAM_NAME_REQUIRED: "El nombre del equipo es obligatorio.",
        ERR_TEAM_NAME_TOO_LONG: "El nombre del equipo debe tener máximo 100 caracteres.",
        ERR_TEAM_QUEUE_REQUIRED: "Se requiere una fila para crear un equipo.",
        ERR_TEAM_QUEUE_NOT_FOUND: "Fila no encontrada o no pertenece a esta empresa.",
        ERR_TEAM_MEMBERS_REQUIRED: "Seleccione al menos un miembro para el equipo.",
        ERR_TEAM_USERS_NOT_IN_QUEUE: "Algunos miembros seleccionados no pertenecen a esta fila.",
        ERR_TEAM_NOT_FOUND: "Equipo no encontrado.",
      },
      myPlan: {
        title: "Mi Plan",
        subtitle: "Tu plan actual y recursos disponibles",
        noPlan: "Plan no encontrado",
        contactSupport: "Contacte con soporte para verificar su plan.",
        limits: {
          title: "Límites del Plan",
          users: "Usuarios",
          connections: "Conexiones",
          queues: "Colas/Sectores",
          unlimited: "∞"
        },
        features: {
          title: "Recursos Habilitados",
          disabledTitle: "Recursos No Incluidos",
          whatsapp: "WhatsApp (Wuzapi)",
          waba: "WhatsApp Business API",
          webchat: "Webchat",
          facebook: "Facebook Messenger",
          instagram: "Instagram Direct",
          telegram: "Telegram",
          campaigns: "Campañas",
          schedules: "Agendamientos",
          callbacks: "Callbacks",
          kanban: "Kanban",
          openai: "Talk.AI",
          integrations: "Integraciones",
          externalApi: "API Externa",
          internalChat: "Chat Interno",
          ifood: "iFood",
          sipPhone: "SIP Phone",
          email: "Email",
          googleCalendar: "Google Calendar"
        },
        footer: "Para cambiar tu plan o agregar recursos, contacte con soporte.",
        contactWhatsApp: "Hablar por WhatsApp",
        whatsappMessage: "¡Hola! Me gustaría saber más sobre los planes y recursos disponibles."
      },

      // ========================================
      // TASKS - Gestión de Tareas
      // ========================================
      tasks: {
        title: "Tareas",
        newTask: "Nueva Tarea",
        editTask: "Editar Tarea",
        viewTask: "Detalles de la Tarea",
        deleteConfirm: "Eliminar tarea",
        deleteMessage: "¿Estás seguro de que deseas eliminar esta tarea?",
        
        // Popover
        popover: {
          title: "Mis Tareas",
          tabs: {
            tasks: "Tareas",
            notifications: "Actividad",
            announcements: "Informativos",
          },
          pending: "pendientes",
          inProgress: "en progreso",
          viewAll: "Ver todas las tareas",
          emptyTasks: "¡No hay tareas pendientes! 🎉",
          emptyNotifications: "No hay notificaciones pendientes",
          approval: {
            title: "Aprobación Solicitada",
            someone: "Alguien",
            wantsToChange: "quiere cambiar",
            from: "de",
            to: "a",
            approve: "Aprobar",
            reject: "Rechazar",
            approved: "¡Cambio de estado aprobado!",
            rejected: "Cambio de estado rechazado",
            error: "Error al procesar la aprobación",
          },
        },
        
        status: {
          pending: "Pendiente",
          in_progress: "En Progreso",
          completed: "Completada",
          cancelled: "Cancelada",
        },
        
        priority: {
          high: "Alta",
          medium: "Media",
          low: "Baja",
        },
        
        fields: {
          title: "Título",
          description: "Descripción",
          priority: "Prioridad",
          status: "Estado",
          dueDate: "Vencimiento",
          participants: "Participantes",
          contact: "Contacto Vinculado",
          createdBy: "Creado por",
          createdAt: "Creado en",
          completedAt: "Completado en",
        },
        
        alerts: {
          title: "Alertas Configuradas",
          firstAlert: "Alerta (días antes)",
          secondAlert: "Alerta (horas/min)",
          none: "Ninguna",
          daysBefore: "{{count}} día antes",
          daysBefore_plural: "{{count}} días antes",
          hoursBefore: "{{count}} hora antes",
          hoursBefore_plural: "{{count}} horas antes",
          minutesBefore: "{{count}} minutos antes",
        },
        
        attachments: {
          title: "Adjuntos",
          upload: "Adjuntar",
          uploading: "Subiendo...",
          download: "Descargar",
          delete: "Eliminar",
          preview: "Vista previa",
          empty: "Sin adjuntos. Haz clic en \"Adjuntar\" para agregar.",
          deleteConfirm: "¿Eliminar adjunto \"{{filename}}\"?",
          uploadSuccess: "¡Adjunto subido con éxito!",
          uploadError: "Error al subir adjunto",
          downloadError: "Error al descargar adjunto",
          deleteError: "Error al eliminar adjunto",
          deleteSuccess: "Adjunto eliminado",
          invalidType: "Tipo de archivo no permitido. Usa imágenes, videos o PDFs.",
          tooLarge: "Archivo demasiado grande. El límite es 50MB.",
          previewTitle: "Vista Previa del Adjunto",
          close: "Cerrar",
          noPreviewAvailable: "Vista previa no disponible para este tipo de archivo",
          previewError: "Error al cargar vista previa",
        },
        
        observations: {
          title: "Observaciones",
          placeholder: "Escribe una observación... Usa @ para mencionar",
          empty: "Sin observaciones aún.",
          reply: "Responder",
          edit: "Editar",
          delete: "Eliminar",
          edited: "editado",
          deleteConfirm: "¿Eliminar esta observación?",
        },
        
        logs: {
          title: "Historial",
          actions: {
            created: "Tarea creada",
            updated: "Tarea actualizada",
            completed: "Tarea completada",
            cancelled: "Tarea cancelada",
            reopened: "Tarea reabierta",
            status_changed: "Estado cambiado",
            participant_added: "Participante agregado",
            participant_removed: "Participante eliminado",
            attachment_added: "Adjunto agregado",
            attachment_removed: "Adjunto eliminado",
            observation_added: "Observación agregada",
          },
        },
        
        buttons: {
          save: "Guardar",
          cancel: "Cancelar",
          close: "Cerrar",
          edit: "Editar Tarea",
          history: "Historial",
          refresh: "Actualizar",
        },
        
        messages: {
          loadError: "Error al cargar tareas",
          saveSuccess: "¡Tarea guardada con éxito!",
          saveError: "Error al guardar tarea",
          deleteSuccess: "¡Tarea eliminada con éxito!",
          deleteError: "Error al eliminar tarea",
          titleRequired: "El título es obligatorio",
        },
        
        ticketMedia: {
          title: "Medios del Ticket",
          preview: "Vista Previa",
          noPreview: "Vista previa no disponible para este tipo de archivo",
          imageAlt: "Medio del ticket",
        },
        
        kanban: {
          emptyColumn: "Sin tareas",
          dragHint: "Arrastra para mover",
          laneEditor: {
            wipLimit: "Límite de tickets (WIP)",
            wipLimitHelp: "Número máximo de tickets simultáneos en esta columna. Deje vacío para sin límite.",
          },
          truncation: {
            message: "Mostrando {shown} de {total} tickets. Reduzca el período para ver todos.",
          },
          groupBy: {
            label: "Agrupar por",
            none: "Ninguno",
            user: "Agente",
            queue: "Cola",
            source: "Origen",
          },
          aging: {
            recent: "Reciente",
            daysInStage: "{days}d en esta etapa",
          },
          search: {
            placeholder: "Buscar tickets...",
            noResults: "No se encontraron tickets",
          },
          keyboard: {
            title: "Atajos de Teclado",
            refresh: "Actualizar datos",
            fullscreen: "Alternar pantalla completa",
            help: "Abrir guía de ayuda",
            escape: "Salir de pantalla completa",
            column: "Desplazarse a la columna N",
          },
        },
      },
      // Embedded Signup - WABA Self-Service
      embeddedSignup: {
        connectWithMeta: "Conectar via Meta Business",
        connectWithCoexistence: "Conectar con Coexistencia",
        connected: "Conectado Exitosamente",
        description: "Conecta tu cuenta WhatsApp Business en pocos clics - sin copiar tokens manualmente",
        descriptionShort: "Conecta en pocos clics - sin copiar tokens",
        orManual: "o configura manualmente abajo",
        // Accordion Labels
        recommended: "Recomendado",
        advanced: "Avanzado",
        manualConfig: "Configuración Manual",
        manualConfigDescription: "IDs y tokens del Facebook Developer Console",
        webhookConfig: "Configuración de Webhook",
        webhookConfigDescription: "Configura para recibir mensajes",
        integrationStatus: "Estado de la Integración",
        integrationStatusDescription: "Validación y prueba de conexión",
        loadingConfig: "Cargando configuración...",
        loadingSDK: "Cargando Facebook SDK...",
        processing: "Procesando registro...",
        success: "¡Conexión WhatsApp Business API creada exitosamente!",
        cancelled: "Registro cancelado",
        cancelledMessage: "El registro fue cancelado. Haz clic para intentar de nuevo.",
        successMessage: "¡Tu cuenta WhatsApp Business API ha sido conectada exitosamente!",
        reviewPending: "Nota: Tu cuenta está en revisión por Meta. Esto puede tardar hasta 72 horas.",
        tryAgain: "Intentar de Nuevo",
        connectionLimitReached: "Límite de {{max}} conexiones WABA alcanzado ({{current}}/{{max}}). Contacta al soporte para aumentar tu límite.",
        featureDisabled: "Embedded Signup no está habilitado para tu empresa. Contacta al soporte.",
        coexistenceDisabled: "El modo coexistencia no está habilitado para tu empresa.",
        step: "Paso",
        of: "de",
        // Coexistence
        coexistenceOption: "Mantener WhatsApp Business App activo (Coexistencia)",
        coexistenceTooltip: "Haz clic para saber más sobre el modo coexistencia",
        coexistenceTitle: "¿Qué es Coexistencia?",
        coexistenceDescription: "Permite usar la aplicación WhatsApp Business y la API oficial al mismo tiempo en el mismo número.",
        coexistenceBenefit1: "Continúa usando la app en tu teléfono",
        coexistenceBenefit2: "Recibe mensajes en ambos canales",
        coexistenceBenefit3: "Importación de historial de hasta 6 meses",
        coexistenceLimitations: "Limitaciones: Los grupos no se sincronizan, algunas funciones de la app quedan deshabilitadas.",
        // Steps
        steps: {
          facebook_login: "Inicio Facebook",
          select_waba: "Seleccionar Cuenta",
          select_phone: "Seleccionar Número",
          verify_phone: "Verificar Número",
          register: "Registrar",
          sync_templates: "Sincronizar Templates",
          complete: "Completado"
        },
        // Steps Descriptions
        stepsDescription: {
          facebook_login: "Inicia sesión con tu cuenta de Facebook para autorizar el acceso.",
          select_waba: "Selecciona o crea tu cuenta WhatsApp Business.",
          select_phone: "Elige el número de teléfono que será conectado.",
          verify_phone: "Verifica el número con el código enviado por SMS o llamada.",
          register: "Registrando el número en la API de WhatsApp Business.",
          sync_templates: "Sincronizando templates de mensajes existentes.",
          complete: "¡Registro finalizado! Tu conexión está lista para usar."
        },
        // Progress
        progress: "Progreso del Registro",
        coexistenceMode: "Modo Coexistencia",
        coexistenceNote: "Modo coexistencia: podrás usar WhatsApp Business App y la API simultáneamente.",
        // Errors
        errors: {
          loadConfigFailed: "Error al cargar configuración. Intenta de nuevo.",
          sdkLoadFailed: "Error al cargar Facebook SDK. Verifica tu conexión.",
          noAppId: "Configuración del Facebook App no encontrada.",
          notAuthorized: "No autorizaste el acceso. Intenta de nuevo.",
          startFailed: "Error al iniciar registro. Intenta de nuevo.",
          processingFailed: "Error al procesar registro. Intenta de nuevo.",
          unknown: "Ocurrió un error desconocido."
        }
      },
      // Quality Rating
      wabaQuality: {
        limit: "Límite",
        green: {
          title: "Quality Rating: Bueno",
          label: "Bueno",
          description: "Tu cuenta está en buen estado. Continúa manteniendo buenas prácticas de mensajes."
        },
        yellow: {
          title: "Quality Rating: Atención",
          label: "Atención",
          description: "Tu cuenta está en alerta. Mejora la calidad de tus mensajes para evitar restricciones."
        },
        red: {
          title: "Quality Rating: Crítico",
          label: "Crítico",
          description: "Tu cuenta está en estado crítico. El límite de mensajes puede ser reducido. Revisa tus prácticas inmediatamente."
        },
        unknown: {
          title: "Quality Rating: Desconocido",
          label: "N/A",
          description: "El quality rating aún no ha sido determinado para esta cuenta."
        }
      },
      // Coexistence Status
      wabaCoexistence: {
        title: "Modo Coexistencia",
        active: "Coexistencia Activa",
        migrated: "Migrado",
        activeDescription: "WhatsApp Business App y la API están funcionando simultáneamente en este número.",
        migratedDescription: "Este número fue migrado del Business App a la API."
      },
      // Review Status
      wabaReview: {
        pending: "Pendiente",
        inProgress: "En Revisión",
        rejected: "Rechazado",
        flagged: "Señalado",
        pending_description: "Tu cuenta está esperando revisión de Meta.",
        review_in_progress_description: "Meta está revisando tu cuenta. Esto puede tardar hasta 72 horas.",
        rejected_description: "Tu cuenta fue rechazada por Meta. Verifica la consola de desarrollador para más detalles.",
        flagged_description: "Tu cuenta ha sido señalada para revisión adicional."
      },
      // OAuth Callback - Página de redirección de Meta
      oauthCallback: {
        // Títulos
        loadingTitle: "Procesando...",
        successTitle: "¡Autorización Completada!",
        errorTitle: "Error de Autorización",
        cancelledTitle: "Autorización Cancelada",
        // Mensajes
        processing: "Espere mientras procesamos su autorización...",
        success: "¡Autorización completada con éxito! Puede volver a la aplicación.",
        successRedirect: "¡Autorización completada! Haga clic en el botón para continuar.",
        error: "Ocurrió un error durante la autorización. Intente nuevamente.",
        cancelled: "Cancelaste el proceso de autorización.",
        noCode: "No se recibió código de autorización. Intente nuevamente.",
        storageError: "Error al guardar datos. Por favor, intente nuevamente.",
        // Acciones
        closeWindow: "Cerrar Ventana",
        goToConnections: "Ir a Conexiones",
        orRedirect: "o",
        closingIn: "Esta ventana se cerrará en {{seconds}} segundos..."
      },
      // Automaciones
      automations: {
        title: "Automatizaciones",
        buttons: {
          add: "Nueva Automatización",
          refresh: "Actualizar",
          clearFilters: "Limpiar Filtros",
        },
        table: {
          status: "Estado",
          name: "Nombre",
          trigger: "Disparador",
          actions: "Acciones",
          executions: "Ejecuciones",
          lastExecution: "Última Ejecución",
          options: "Opciones",
        },
        triggers: {
          ticket_created: "Ticket Creado",
          funnel_entry: "Entrada en Embudo",
          funnel_move: "Cambio de Etapa",
          time_in_stage: "Tiempo en Etapa",
          inactivity: "Inactividad",
          score_changed: "Score Cambiado",
          value_set: "Valor Definido",
          message_received: "Mensaje Recibido",
          ticket_closed: "Ticket Cerrado",
          user_assigned: "Agente Asignado",
          queue_changed: "Cola Cambiada",
          first_response: "Primera Respuesta",
          contact_returned: "Contacto Regresó",
          keyword_detected: "Palabra Clave Detectada",
          sla_warning: "Alerta de SLA",
          sla_breached: "SLA Violado",
          media_received: "Media Recibida",
          ticket_transferred: "Ticket Transferido",
          birthday_today: "Cumpleaños Hoy",
          business_hours_start: "Inicio de Horario Comercial",
          business_hours_end: "Fin de Horario Comercial",
          contact_created: "Contacto Creado",
          contact_field_updated: "Campo de Contacto Actualizado",
          webhook_received: "Webhook Recibido",
          ai_handoff_triggered: "Handoff de IA",
          ai_response_generated: "Respuesta de IA Generada",
          ai_sentiment_detected: "Sentimiento Detectado por IA",
          ai_intent_classified: "Intención Clasificada por IA",
          ai_tool_executed: "Herramienta de IA Ejecutada",
          ai_turn_limit_approaching: "Límite de Turnos Próximo",
          tag_added: "Etiqueta Agregada",
          tag_removed: "Etiqueta Removida",
          ticket_reopened: "Ticket Reabierto",
          nps_received: "NPS Recibido",
          outside_business_hours: "Fuera de Horario Comercial",
        },
        aiActions: {
          activate_autonomous_mode: "Activar Modo Autónomo",
          aiConfigurationId: "Agente de IA",
          maxTurnsOverride: "Límite de Turnos (Override)",
          customContextPrompt: "Contexto Adicional",
          fallbackActionOverride: "Acción de Fallback (Override)",
          sendInitialMessage: "Enviar Mensaje Inicial",
          initialMessage: "Mensaje Inicial",
          maxActivationDepth: "Profundidad Máxima",
        },
        actionConfigs: {
          ai_summarize_ticket: "Resumir Ticket con IA",
          ai_classify_intent: "Clasificar Intención con IA",
          ai_analyze_sentiment: "Analizar Sentimiento con IA",
          ai_generate_voice: "Generar Audio con IA",
          ai_smart_route: "Enrutamiento Inteligente con IA",
          ai_handoff_summary: "Generar Briefing de Handoff",
          ai_pause_autonomous: "Pausar Modo Autónomo",
          add_internal_note: "Agregar Nota Interna",
          send_reaction: "Enviar Reacción (Emoji)",
          transfer_ticket: "Transferir Ticket",
          mark_as_resolved: "Marcar como Resuelto",
          summaryFormat: "Formato del Resumen",
          summaryFormatOptions: {
            brief: "Breve",
            detailed: "Detallado",
            bullet: "Puntos",
          },
          includeActionItems: "Incluir ítems de acción",
          includeSentiment: "Incluir sentimiento",
          saveAsNote: "Guardar como nota en el ticket",
          minConfidence: "Confianza Mínima",
          autoRoute: "Auto-enrutar basado en intención",
          saveAsTag: "Guardar intención como etiqueta",
          escalateOnNegative: "Escalar en sentimiento negativo",
          escalateQueueId: "Cola de Escalación",
          notifySupervisor: "Notificar supervisor",
          text: "Texto para generar audio",
          textPlaceholder: "Hola {{contact.name}}, tu ticket #{{ticket.id}}...",
          provider: "Proveedor de Voz",
          voiceId: "ID de Voz",
          allowQueueChange: "Permitir cambio de cola",
          allowAgentChange: "Permitir cambio de agente",
          notifyOnRoute: "Notificar sobre enrutamiento",
          attachToTicket: "Adjuntar briefing al ticket",
          includeStepsTaken: "Incluir pasos realizados",
          includeSuggestedActions: "Incluir acciones sugeridas",
          notifyAgent: "Notificar agente",
          notifyOnPause: "Notificar al pausar",
          noteContent: "Contenido de la Nota",
          noteContentPlaceholder: "Use {{contact.name}} y {{ticket.id}} como variables",
          emoji: "Emoji",
          emojiPlaceholder: "👍",
          targetType: "Tipo de Transferencia",
          targetTypeOptions: {
            queue: "Cola",
            user: "Agente",
          },
          targetQueueId: "Cola de Destino",
          targetUserId: "Agente de Destino",
          keepCurrentUser: "Mantener agente actual en la cola",
          addNote: "Agregar nota de resolución",
          noteMessage: "Mensaje de la Nota",
          noteMessagePlaceholder: "Ticket resuelto por automatización.",
        },
        aiTriggers: {
          handoffReasons: "Motivos de Handoff",
          aiConfigurationIds: "Agentes de IA",
          fallbackActions: "Acciones de Fallback",
          confidenceThreshold: "Rango de Confianza",
          turnCountThreshold: "Después de N Turnos",
          handoffReasonsOptions: {
            low_confidence: "Baja Confianza",
            turn_limit: "Límite de Turnos",
            customer_request: "Cliente Pidió Humano",
            customer_satisfied: "Cliente Satisfecho",
            error: "Error",
            timeout: "Timeout",
          },
          fallbackActionsOptions: {
            notify_supervisor: "Notificar Supervisor",
            transfer_queue: "Transferir a Cola",
            notify_owner: "Notificar Dueño",
            pause_bot: "Pausar Bot",
            close_ticket: "Cerrar Ticket",
          },
        },
        modal: {
          createTitle: "Nueva Automatización",
          editTitle: "Editar Automatización",
          save: "Guardar",
          cancel: "Cancelar",
          sections: {
            basicInfo: "Información Básica",
            trigger: "Disparador (Cuándo ejecutar)",
            actions: "Acciones (Qué hacer)",
            preview: "Vista Previa del Flujo",
          },
          fields: {
            name: "Nombre de la Automatización",
            description: "Descripción",
            priority: "Prioridad",
            active: "Activa",
            triggerType: "Tipo de Disparador",
            stageId: "ID de Etapa",
            delayMinutes: "Delay (minutos)",
          },
        },
        confirmDelete: {
          title: "Eliminar Automatización",
          message: "¿Está seguro que desea eliminar la automatización \"{{name}}\"? Esta acción no se puede deshacer.",
        },
        logs: {
          title: "Logs de Ejecución",
          empty: "No se encontraron logs",
          columns: {
            date: "Fecha",
            action: "Acción",
            status: "Estado",
            time: "Tiempo",
            error: "Error",
          },
          status: {
            success: "Éxito",
            error: "Error",
            skipped: "Ignorado",
          },
        },
        empty: {
          title: "No se encontraron automatizaciones",
          description: "Cree su primera automatización para comenzar",
        },
        toasts: {
          created: "Automatización creada con éxito",
          updated: "Automatización actualizada con éxito",
          deleted: "Automatización eliminada con éxito",
          activated: "Automatización activada",
          deactivated: "Automatización desactivada",
          duplicated: "Automatización duplicada",
          error: "Error al procesar automatización",
        },
      },
      pauseModal: {
        title: "Modo Pausa",
        subtitle: "Seleccione la duración de su pausa",
        confirm: "Activar Pausa",
        cancel: "Cancelar",
        options: {
          quick: {
            label: "15 min",
            description: "Pausa rápida",
          },
          coffee: {
            label: "30 min",
            description: "Café / descanso",
          },
          lunch: {
            label: "1h30",
            description: "Almuerzo",
          },
          manual: {
            label: "Manual",
            description: "Define el tiempo",
          },
        },
        customTime: {
          title: "Defina la duración",
          hours: "horas",
          minutes: "minutos",
          totalLabel: "Total",
          selectDuration: "Seleccione la duración",
        },
      },
      calendarSelector: {
        all: "Todos",
        institutional: "Institucional",
        personal: "Personal",
        loading: "Cargando calendarios...",
        error: "Error al cargar calendarios",
        label: "Calendario",
        placeholder: "Seleccione un calendario",
      },
      calendar: {
        reassign: {
          title: "Reasignar Agendamiento",
          targetUser: "Usuario destino",
          targetQueue: "Fila destino",
          selectQueue: "Selecione una fila",
          reason: "Motivo (opcional)",
          reasonPlaceholder: "Ej.: Transferencia de equipo",
          submit: "Reasignar",
          cancel: "Cancelar",
          processing: "Reasignando...",
          success: "¡Agendamiento reasignado con éxito!",
          selectUserAndQueue: "Seleccione el usuario y fila de destino",
        },
      },
      calendarManagement: {
        title: "Gestionar Agendas",
        subtitle: "Agendas personales de agentes y sub-agendas por cola",
        institutionalSection: "Agenda de la Empresa",
        personalSection: "Agendas Personales",
        subCalendarSection: "Provisionar Sub-agenda",
        noInstitutional: "Ninguna agenda institucional conectada.",
        noPersonal: "Ninguna agenda personal conectada aún.",
        connectPersonal: "Conectar agenda personal para:",
        disconnect: "Desconectar agenda",
        removeSubCalendar: "Eliminar sub-agenda",
        selectUser: "Agente",
        selectQueue: "Cola / Especialidad",
        provision: "Crear Sub-agenda",
        close: "Cerrar",
      },
      moments: {
        title: "Panel de Atenciones en Tiempo Real",
        empty: {
          title: "No se encontraron tickets",
          subtitle: "Los tickets aparecerán aquí cuando estén disponibles",
          noResults: "Sin resultados para los filtros seleccionados",
        },
        toolbar: {
          filters: "Filtros",
          groupByUser: "Agrupar por agente",
          groupByQueue: "Agrupar por cola",
          compactMode: "Modo compacto",
          alerts: "Alertas sonoras",
          help: "Ayuda",
          refresh: "Actualizar datos",
          fullscreen: "Pantalla completa",
          exitFullscreen: "Salir de pantalla completa (ESC)",
          collapseOffline: "Colapsar offline",
        },
        filters: {
          search: "Buscar contacto o ticket...",
          clear: "Limpiar filtros",
          queue: "Filtrar por cola",
          status: "Filtrar por estado",
          connection: "Filtrar por conexión",
        },
        status: {
          online: "En línea",
          paused: "En Pausa",
          offline: "Desconectado",
          pending: "Pendientes",
        },
        column: {
          noTickets: "Sin tickets",
          avgResponseTime: "Tiempo promedio de respuesta",
          avgFirstResponse: "Tiempo promedio de 1ª respuesta",
          avgQueueTime: "Tiempo promedio en cola",
          urgentTooltip: "esperando respuesta hace más de 30 minutos",
          capacity: "Capacidad",
          collapse: "Colapsar",
          expand: "Expandir",
        },
        ticket: {
          view: "Ver ticket",
          queue: "Cola",
          noQueue: "SIN COLA",
          connection: "Conexión",
          noConnection: "SIN CONEXIÓN",
          waitingSince: "Esperando respuesta desde hace",
        },
        contextMenu: {
          open: "Abrir ticket",
          transfer: "Transferir ticket",
          assume: "Asumir ticket",
          close: "Cerrar ticket",
        },
        actions: {
          transferSuccess: "Ticket transferido con éxito",
          assumeSuccess: "Ticket asumido con éxito",
          closeSuccess: "Ticket cerrado con éxito",
        },
        confirmClose: {
          title: "Cerrar ticket",
          message: "¿Está seguro de que desea cerrar este ticket? Esta acción no se puede deshacer.",
          cancel: "Cancelar",
          confirm: "Cerrar",
        },
        preview: {
          title: "Últimos mensajes",
          empty: "No se encontraron mensajes",
          openFull: "Abrir conversación completa",
        },
        alerts: {
          title: "Configurar Alertas Sonoras",
          enable: "Activar alertas sonoras",
          waitThreshold: "Alertar cuando ticket espere",
          pendingThreshold: "Alertar cuando pendientes alcancen",
          close: "Cerrar",
        },
        help: {
          title: "Ayuda - Panel de Atenciones",
          statusColors: "Colores del Encabezado",
          green: "Verde",
          greenDesc: "Agente en línea y disponible",
          yellow: "Amarillo",
          yellowDesc: "Agente en pausa (almuerzo/descanso)",
          red: "Rojo",
          redDesc: "Agente desconectado (no iniciado sesión)",
          gray: "Gris",
          grayDesc: "Tickets pendientes (sin agente asignado)",
          interactionTitle: "Interacción con Tickets",
          dragDrop: "Arrastre tickets entre columnas para transferir (solo supervisores/admins)",
          rightClick: "Haga clic derecho en un ticket para acciones rápidas (transferir, asumir, cerrar)",
          hoverPreview: "Pase el mouse sobre un ticket para previsualizar los últimos mensajes",
          toolbarTitle: "Barra de Herramientas",
          filterDesc: "Use los filtros para buscar por nombre/ID, filtrar por estado del agente (en línea, pausa, offline) o por cola",
          groupByDesc: "Alterne entre agrupar por agente (vista individual) o por cola/departamento (vista departamental)",
          compactDesc: "Active el modo compacto para ver más tickets por columna — muestra solo nombre, tiempo y badges en una línea",
          collapseDesc: "Haga clic en la flecha del encabezado de columna para colapsarla. Haga clic de nuevo para expandir. El estado se guarda automáticamente",
          metricsTitle: "Métricas e Indicadores",
          capacityDesc: "La barra de color en el encabezado indica la capacidad: verde (ligera), amarillo (moderada), rojo (sobrecargada)",
          timerDesc: "Los tickets en espera muestran un temporizador en vivo con borde rojo. Después de 30 min, la tarjeta pulsa",
          urgentBadge: "La insignia roja con número indica tickets urgentes esperando más de 30 minutos",
          alertsTitle: "Alertas Sonoras",
          alertsDesc: "Configure alertas para ser notificado cuando tickets esperan demasiado o cuando hay muchos pendientes en cola",
          fullscreenDesc: "Use el modo de pantalla completa para una vista expandida. Presione ESC para salir",
        },
      },
    }
  },
};

export { messages };
